export function Logo(props: { width?: number; height?: number }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={props.width ?? '197'}
      height={props.height ?? '85'}
      fill='none'
      viewBox='0 0 197 85'>
      <path
        fill='#6D397B'
        d='M67.288 42.39c0 7.79.006 15.566.006 23.355 0 .888.768 1.614 1.706 1.614.939 0 1.707-.726 1.707-1.614v-.293h-.015V42.39h2.18v5.861c2.314-4.38 6.263-6.57 11.847-6.57 3.813 0 7.013 1.246 9.6 3.736 2.588 2.49 3.881 5.518 3.881 9.082v16.875h-2.179V54.499c0-2.963-1.1-5.54-3.302-7.73-2.201-2.19-4.868-3.284-8-3.284-3.132 0-5.89 1.096-8.273 3.285l-.107.1-.004.003-.101.096-.008.007-.096.094-.011.01-.106.105-.086.087-.018.018-.08.084-.022.022-.03.032-.07.074-.072.078-.026.029-.067.074-.03.034-.063.07-.033.037-.023.028c-.053.06-.105.123-.156.184l-.005.006-.05.061-.006.007-.15.187-.015.02-.044.056-.038.05-.046.061-.035.047-.017.024-.06.08-.008.013-.064.09-.008.01-.052.075-.003.005-.052.076-.023.032-.02.032-.055.082-.019.029-.055.086-.016.024-.02.03-.05.082-.058.096-.01.016-.059.1-.007.013-.06.104-.005.009-.06.109-.003.005-.061.113-.06.115-.002.004-.057.112-.003.008-.001.002-.058.118-.049.104-.007.016-.046.1-.01.021-.042.097-.01.025-.04.093-.012.029-.037.09-.004.01-.037.094-.005.015-.015.037-.03.082-.004.008-.025.07-.03.081-.002.007-.025.074-.005.014-.03.089-.006.018-.017.056-.006.018-.032.101-.002.007-.018.062-.007.022-.02.072-.021.072-.007.026-.015.054-.004.015-.026.1-.006.024-.025.105-.001.004-.02.083-.01.041-.003.016a9.62 9.62 0 00-.048.229l-.001.007-.02.098-.005.028-.018.103-.004.024-.018.108-.003.019-.017.113-.002.015-.016.118-.001.01-.016.123v.006l-.015.128v.002l-.012.13v.003l-.011.127-.001.008-.009.123c-.008.131-.014.263-.018.396v11.551c0 2.016-1.744 3.666-3.876 3.666-2.132 0-3.876-1.65-3.876-3.666h-.015V64.16c-1.27 2.448-3.177 4.38-5.719 5.797a16.52 16.52 0 01-8.17 2.126c-4.45 0-8.262-1.493-11.44-4.477-3.177-2.984-4.766-6.559-4.766-10.724s1.589-7.74 4.766-10.724c3.178-2.984 6.99-4.476 11.44-4.476 2.904 0 5.685.73 8.34 2.19 2.655 1.46 4.505 3.392 5.55 5.796V42.39h2.178zM171.49 79.548c-.49-.432-.956-.905-1.392-1.424-.535-.515-1.222-1.054-2.105-1.336-1.403-.449-2.004-.142-2.7-.191.609-.33.754-.47 1.568-.873 1.656-.82 3.453-1.406 5.506-1.314 4.025.18 3.99 2.9 2.328 3.446-.77.254-1.293.014-2.125-.264.095.129.187.272.278.425.919.972 1.97 1.81 3.146 2.506 2.056 1.217 4.219 1.83 6.482 1.83 3.348 0 6.244-1.145 8.687-3.435 2.444-2.29 3.665-5.04 3.665-8.25v-4.88c-2.217 4.195-6.086 6.292-11.606 6.292-3.755 0-6.971-1.255-9.637-3.756-2.667-2.501-4.005-5.51-4.005-9.02V42.483h2.172v16.82c0 2.949 1.143 5.522 3.428 7.705 2.284 2.183 4.988 3.274 8.11 3.274 3.122 0 5.826-1.091 8.111-3.274 2.284-2.183 3.427-4.75 3.427-7.704V42.483H197v27.992c0 3.804-1.406 7.044-4.208 9.695-2.803 2.65-6.244 3.98-10.316 3.98-4.542 0-8.204-1.534-10.986-4.602zM64.892 59.988l.06-.264.005-.023.007-.029.026-.13.026-.132.005-.026.02-.106.009-.054.004-.023.019-.111.004-.026.008-.051.017-.11.003-.023.02-.135V55.09l-.001-.003-.001-.006c-.014-.102-.03-.203-.045-.303l-.003-.014-.012-.076-.015-.084-.002-.013-.027-.148-.004-.02-.025-.132-.002-.006a12.38 12.38 0 00-.067-.31l-.003-.012-.03-.13-.006-.022-.01-.042-.029-.114-.004-.015-.034-.129-.003-.011-.032-.118-.011-.037-.01-.033-.029-.099-.013-.044-.031-.1-.01-.032-.011-.037-.038-.116-.003-.01-.043-.126-.005-.016-.053-.148v-.003l-.03-.083-.026-.068-.022-.057-.035-.092v-.001l-.057-.142-.003-.007-.002-.006-.05-.122-.009-.02-.044-.103-.02-.045-.033-.077-.032-.07-.023-.051-.044-.096-.012-.026-.058-.12-.059-.12-.012-.024v-.002l-.068-.132-.014-.027-.053-.1-.014-.027-.024-.046-.053-.097-.078-.139-.002-.003-.079-.137-.002-.004-.053-.09-.03-.051-.04-.065-.046-.075-.026-.04-.062-.1-.01-.016-.074-.115-.005-.007-.07-.107-.022-.03-.056-.084-.01-.013-.054-.08-.014-.02-.055-.077-.025-.036-.072-.1-.01-.012-.082-.112-.008-.011-.075-.1-.007-.01-.069-.088-.017-.022-.066-.085-.013-.017-.064-.08-.024-.03-.083-.102-.007-.007-.09-.109-.013-.015-.08-.094-.031-.037-.062-.07-.052-.06-.008-.008-.084-.095-.024-.026-.023-.026-.094-.103-.004-.004-.099-.106-.017-.018-.083-.087-.039-.04-.063-.065-.06-.062-.044-.043-.082-.082-.022-.022-.106-.104c-2.746-2.662-6.026-3.993-9.839-3.993-3.813 0-7.115 1.342-9.906 4.025-2.792 2.684-4.188 5.83-4.188 9.437 0 3.606 1.396 6.73 4.188 9.37 2.791 2.642 6.105 3.962 9.94 3.962 3.836 0 7.116-1.32 9.84-3.961l.104-.103.022-.021.082-.082.043-.043.059-.06.063-.066.038-.039.083-.087.017-.018.098-.105.004-.004.093-.102.023-.026.016-.017.086-.097.013-.014.051-.059.062-.07.03-.036.08-.095.012-.014.09-.108.007-.008.081-.1.063-.078.025-.031.043-.055.043-.055.02-.026.06-.08.004-.004.076-.101.007-.01.082-.11.01-.014.07-.099.051-.071.068-.098.004-.006.068-.1.023-.034.02-.028.005-.01.104-.159.05-.078.061-.096.027-.042.044-.073.04-.066.03-.05.053-.09.08-.141.001-.001.065-.117.014-.024.05-.094.052-.096.011-.022.038-.073.023-.046.05-.098.069-.14.002-.004.055-.116.038-.082.018-.038.024-.055.03-.067.035-.08.018-.041.045-.106.007-.016.05-.123.004-.009.045-.114.013-.035.035-.088.023-.061.023-.063.031-.088.014-.037.04-.113.003-.012.042-.125.005-.015.008-.026.04-.124.001-.003.026-.085.007-.02.025-.085.007-.021.027-.095.043-.155.001-.006.034-.129.006-.02.027-.109.011-.047.007-.028zm48.447 9.973v1.798c-3.212 0-5.95-1.017-8.212-3.05-2.262-2.033-3.394-4.633-3.394-7.8V30.862h2.172v11.685h9.366v1.798h-9.366v16.564c0 2.61.917 4.773 2.749 6.484 1.832 1.712 4.061 2.568 6.685 2.568zm30.574-27.478v28.89h-2.172v-7.19c-1.266 2.44-3.169 4.368-5.701 5.778a16.479 16.479 0 01-8.144 2.119c-4.435 0-8.237-1.49-11.403-4.462-3.165-2.972-4.751-6.538-4.751-10.69 0-4.151 1.586-7.717 4.751-10.69 3.166-2.972 6.968-4.462 11.403-4.462 2.895 0 5.669.73 8.314 2.183 2.645 1.454 4.491 3.381 5.531 5.779v-7.255h2.172zm-29.999 14.51c0 3.595 1.392 6.709 4.174 9.34 2.783 2.633 6.086 3.95 9.909 3.95 3.824 0 7.095-1.319 9.808-3.95 2.713-2.63 4.072-5.756 4.072-9.372 0-3.617-1.371-6.755-4.106-9.407-2.736-2.651-6.007-3.98-9.807-3.98-3.801 0-7.093 1.338-9.876 4.013-2.782 2.675-4.174 5.81-4.174 9.406zm41.932-13.483c-1.177 0-2.22.366-3.122 1.091-.902.726-1.358 1.627-1.358 2.697s.512 2.057 1.527 2.953c1.016.897 2.242 1.726 3.665 2.472a98.68 98.68 0 014.31 2.408 12.86 12.86 0 013.699 3.274c1.016 1.324 1.527 2.846 1.527 4.558 0 2.526-1.007 4.676-3.02 6.453-2.013 1.776-4.445 2.664-7.296 2.664-1.81 0-3.498-.376-5.056-1.123-1.559-.747-2.704-1.745-3.428-2.986V64.89c1.72 3.596 4.48 5.393 8.28 5.393 2.353 0 4.335-.686 5.939-2.054 1.604-1.367 2.41-2.9 2.41-4.59 0-1.691-.51-3.114-1.527-4.27-1.018-1.156-2.254-2.143-3.7-2.954-1.445-.81-2.887-1.617-4.31-2.407-1.422-.79-2.649-1.757-3.664-2.89-1.016-1.13-1.528-2.46-1.528-3.98 0-1.519.648-2.806 1.935-3.852 1.287-1.046 2.952-1.572 4.988-1.572 2.036 0 3.778.748 5.226 2.246v2.633c-1.448-2.055-3.28-3.082-5.497-3.082z'></path>
      <path
        fill='#6D397B'
        fillRule='evenodd'
        d='M38.89 24.31c2.922 0 5.634.987 7.721 2.467l3.026-7.204C35.982 11.743 20.11 17.428 20.11 33.39v37.984h10.016V56.261h12.202v-7.797h-12.41V33.49c0-6.02 3.025-9.18 8.973-9.18z'
        clipRule='evenodd'></path>
      <path
        fill='#6D397B'
        fillRule='evenodd'
        d='M25.326 18.718c3.861-4.008-5.98-7.773-8.043-14.63-.437-1.454-.252-2.966-.743-4.088-2.914 2.903-3.432 6.587-2.437 10.33.93 3.496 7.35 11.192.088 16.139-4.767 3.246-6.443-2.21-4.768-6.176.36-.852.878-1.53 1.488-2.271.611-.744 1.565-1.395 1.65-2.208-1.216.15-3.292 1.5-4.469 2.347-12.354 8.912 9.78 31.045 1.003 36.282-3.042 1.816-5.397-.943-5.664-3.61-.369-3.675.27-4.54.292-5.942-11.707 19.73 7.237 27.35 15.07 26.305V33.39c0-6.604 2.562-11.556 6.533-14.672z'
        clipRule='evenodd'></path>
      <path
        fill='#5C386F'
        d='M67.287 42.39c0 7.79.005 15.566.005 23.356 0 .888.768 1.614 1.707 1.614.938 0 1.706-.727 1.706-1.614v-.294h-.014V42.39h2.179v5.862c2.315-4.38 6.264-6.57 11.847-6.57 3.813 0 7.014 1.245 9.601 3.735 2.587 2.491 3.881 5.518 3.881 9.082v16.876H96.02V54.499c0-2.963-1.1-5.539-3.302-7.729-2.202-2.19-4.869-3.285-8-3.285-3.133 0-5.891 1.096-8.273 3.285l-.107.1-.004.003-.102.096-.007.008-.097.093-.01.01-.106.105-.086.087-.018.018-.081.084-.021.022-.03.032-.07.075-.072.077-.027.03-.067.074-.03.033-.063.07-.032.038-.023.027-.156.184-.006.007-.05.06-.005.007-.15.187-.015.02-.044.057-.038.05-.047.061-.035.047-.017.023-.059.08-.009.013-.064.09-.008.011-.051.074-.004.005-.052.076-.022.032-.021.032-.055.083-.018.028-.056.087-.015.024-.02.03-.05.081-.058.096-.01.017-.06.1-.007.012-.06.105-.004.008-.06.11-.003.004-.062.114-.06.115-.002.004-.056.111-.004.008-.001.003-.057.117-.05.104-.007.017-.046.1-.009.02-.043.097-.01.025-.04.093-.012.03-.036.089-.005.01-.036.094-.006.015-.014.038-.031.081-.003.008-.026.07-.029.082-.002.007-.026.074-.004.013-.03.089-.006.019-.018.055-.006.019-.03.1-.003.008-.019.062-.006.022-.021.07-.02.074-.008.026-.014.053-.004.016-.026.1-.006.024-.026.104v.004l-.02.084-.01.04-.003.017a9.175 9.175 0 00-.049.228l-.001.007-.019.098-.005.028-.018.103-.004.024-.018.108-.003.02-.017.113-.002.014-.017.118v.01l-.016.124v.005l-.015.129v.001l-.013.13v.004l-.01.126-.002.009-.008.123c-.008.13-.015.262-.019.396v11.55c0 2.016-1.744 3.666-3.875 3.666-2.132 0-3.876-1.65-3.876-3.665v-.001h-.015V64.16c-1.271 2.447-3.178 4.38-5.72 5.797a16.518 16.518 0 01-8.17 2.125c-4.449 0-8.262-1.492-11.44-4.476-3.177-2.985-4.766-6.56-4.766-10.724 0-4.166 1.589-7.74 4.767-10.725 3.177-2.984 6.99-4.476 11.439-4.476 2.905 0 5.685.73 8.34 2.19 2.656 1.46 4.506 3.392 5.55 5.797V42.39h2.179zm104.202 37.158a13.364 13.364 0 01-1.391-1.423c-.535-.516-1.222-1.054-2.106-1.337-1.403-.448-2.003-.142-2.699-.19.608-.33.753-.47 1.568-.873 1.655-.821 3.453-1.407 5.506-1.315 4.025.18 3.99 2.9 2.328 3.447-.77.253-1.293.013-2.125-.264.095.128.187.272.277.425.92.972 1.971 1.81 3.147 2.506 2.056 1.216 4.219 1.83 6.482 1.83 3.348 0 6.244-1.145 8.687-3.436 2.444-2.29 3.665-5.04 3.665-8.25v-4.88c-2.217 4.196-6.086 6.293-11.606 6.293-3.755 0-6.971-1.255-9.638-3.756-2.666-2.502-4.004-5.511-4.004-9.02V42.482h2.172v16.821c0 2.948 1.143 5.522 3.427 7.705 2.285 2.182 4.989 3.274 8.111 3.274 3.122 0 5.826-1.092 8.111-3.274 2.285-2.183 3.427-4.752 3.427-7.705V42.483H197v27.993c0 3.804-1.405 7.043-4.208 9.694-2.803 2.652-6.244 3.98-10.316 3.98-4.542 0-8.204-1.533-10.987-4.602zM64.89 59.988c.021-.087.041-.176.06-.264l.006-.023.006-.028.026-.13v-.001l.027-.131.005-.027.019-.105.01-.054.003-.023.019-.112.004-.025.008-.052.017-.11.004-.023.019-.134v-3.659l-.002-.007-.045-.303-.002-.013-.013-.076-.014-.085-.002-.012-.028-.148-.003-.02-.026-.132-.001-.007a12.291 12.291 0 00-.067-.31l-.003-.012-.031-.13-.005-.021-.01-.043-.03-.113-.003-.016-.035-.129-.002-.01-.033-.118-.01-.038-.01-.033-.03-.099-.013-.044-.03-.1-.01-.032-.012-.036-.038-.116-.003-.01-.042-.126-.006-.016-.052-.148-.001-.004-.03-.083-.025-.067-.022-.057-.036-.093-.056-.143-.003-.006-.002-.006-.051-.123-.009-.02-.043-.103-.02-.045-.034-.077-.031-.07-.024-.051-.044-.095-.012-.026-.057-.12-.06-.12-.012-.025v-.002l-.067-.131-.015-.028-.052-.1-.014-.027-.025-.045-.053-.097-.078-.14-.001-.002-.08-.138-.002-.004-.052-.09-.031-.05-.04-.066-.046-.075-.025-.04-.062-.099-.01-.017-.075-.114-.005-.007-.07-.108-.021-.03-.056-.083-.01-.014-.055-.08-.014-.02-.054-.077-.026-.036-.072-.1-.009-.012-.082-.112-.008-.01-.076-.101-.007-.01-.068-.088-.017-.022-.067-.085-.013-.016-.063-.08-.025-.03-.083-.102-.006-.008-.09-.109-.013-.015-.08-.094-.032-.036-.062-.071-.052-.06-.007-.008-.085-.095-.023-.026-.024-.026-.094-.103-.004-.003-.099-.106-.017-.019-.083-.087-.038-.04-.064-.065-.06-.061-.043-.043-.083-.083-.022-.022-.105-.103c-2.747-2.663-6.026-3.994-9.84-3.994-3.812 0-7.115 1.342-9.906 4.026-2.792 2.684-4.188 5.829-4.188 9.436s1.396 6.73 4.188 9.371c2.791 2.641 6.105 3.962 9.94 3.962 3.837 0 7.116-1.321 9.84-3.962l.105-.102.021-.022.082-.082.043-.043.06-.06.063-.065.037-.04.083-.087.017-.017.098-.105.004-.005.093-.1.024-.028.015-.017.086-.097.013-.014.051-.058.062-.071.03-.036.08-.094.013-.014.09-.108.007-.009.08-.1.063-.078.025-.03.043-.055.043-.055.02-.026.061-.08.003-.004.077-.102.007-.01.081-.11.01-.014.07-.098.052-.072.068-.098.004-.006.068-.1.023-.033.019-.029.006-.01.104-.158.05-.078.06-.096.027-.043.044-.072.04-.067.03-.049.053-.091.081-.14v-.002l.066-.116.013-.024.05-.094.001-.002.051-.095.011-.021.038-.074.023-.045.05-.099.07-.14.001-.004.055-.115.038-.082.018-.04.025-.054.03-.066.035-.08.017-.042.045-.106.007-.016.05-.122.004-.01.045-.113.014-.036.034-.088.023-.06.023-.064.032-.087.013-.037.04-.114.004-.011.042-.126.005-.015.008-.025.04-.125v-.002l.027-.085.006-.021.025-.085.007-.021.027-.095.043-.154.002-.007.034-.128.005-.02.027-.11.012-.046.006-.028zm48.448 9.974v1.797c-3.213 0-5.95-1.016-8.212-3.049-2.263-2.033-3.394-4.633-3.394-7.8V30.861h2.172v11.685h9.366v1.798h-9.366v16.564c0 2.61.917 4.773 2.749 6.485 1.832 1.712 4.061 2.568 6.685 2.568zm30.574-27.48v28.893h-2.171v-7.191c-1.267 2.44-3.17 4.368-5.701 5.778a16.484 16.484 0 01-8.145 2.119c-4.434 0-8.237-1.49-11.403-4.462-3.165-2.973-4.751-6.538-4.751-10.69 0-4.152 1.586-7.717 4.751-10.69 3.166-2.973 6.969-4.462 11.403-4.462 2.896 0 5.669.73 8.314 2.183 2.645 1.453 4.491 3.381 5.532 5.778v-7.255h2.171zm-29.999 14.51c0 3.596 1.392 6.71 4.174 9.343 2.783 2.632 6.086 3.948 9.91 3.948 3.823 0 7.094-1.318 9.807-3.948s4.072-5.758 4.072-9.374c0-3.617-1.37-6.754-4.106-9.406-2.735-2.652-6.006-3.98-9.807-3.98s-7.093 1.337-9.876 4.012c-2.782 2.675-4.174 5.81-4.174 9.406zm41.932-13.482a4.852 4.852 0 00-3.122 1.092c-.902.725-1.357 1.626-1.357 2.696 0 1.07.512 2.057 1.527 2.953 1.016.897 2.242 1.726 3.665 2.473a98.149 98.149 0 014.31 2.407 12.888 12.888 0 013.699 3.274c1.016 1.325 1.527 2.847 1.527 4.559 0 2.525-1.007 4.676-3.02 6.452-2.014 1.776-4.446 2.665-7.296 2.665-1.81 0-3.499-.377-5.057-1.124-1.558-.746-2.704-1.744-3.427-2.985V64.89c1.719 3.595 4.479 5.393 8.28 5.393 2.353 0 4.335-.687 5.939-2.054 1.604-1.368 2.409-2.9 2.409-4.59 0-1.691-.509-3.115-1.527-4.27-1.017-1.156-2.253-2.143-3.699-2.954-1.445-.81-2.887-1.618-4.31-2.407-1.423-.79-2.65-1.758-3.665-2.89-1.016-1.131-1.527-2.46-1.527-3.98s.647-2.806 1.934-3.852c1.287-1.047 2.953-1.573 4.989-1.573s3.778.749 5.226 2.247v2.632c-1.448-2.054-3.281-3.082-5.498-3.082z'></path>
      <path
        fill='#33324F'
        fillRule='evenodd'
        d='M20.108 70.548l10.016.494v.333H20.108v-.827z'
        clipRule='evenodd'></path>
      <path
        fill='#33324F'
        fillRule='evenodd'
        d='M20.108 70.332l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#33324F'
        fillRule='evenodd'
        d='M20.108 70.116l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#33324F'
        fillRule='evenodd'
        d='M20.108 69.9l10.016.494v.324l-10.016-.494V69.9z'
        clipRule='evenodd'></path>
      <path
        fill='#343350'
        fillRule='evenodd'
        d='M20.108 69.684l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#343350'
        fillRule='evenodd'
        d='M20.108 69.468l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#343350'
        fillRule='evenodd'
        d='M20.108 69.252l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#353350'
        fillRule='evenodd'
        d='M20.108 69.036l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#353350'
        fillRule='evenodd'
        d='M20.108 68.82l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#353351'
        fillRule='evenodd'
        d='M20.108 68.604l10.016.493v.325l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#353351'
        fillRule='evenodd'
        d='M20.108 68.388l10.016.493v.325l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#353351'
        fillRule='evenodd'
        d='M20.108 68.172l10.016.493v.325l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#353351'
        fillRule='evenodd'
        d='M20.108 67.956l10.016.493v.325l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#353351'
        fillRule='evenodd'
        d='M20.108 67.74l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#353351'
        fillRule='evenodd'
        d='M20.108 67.524l10.016.493v.325l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#353351'
        fillRule='evenodd'
        d='M20.108 67.308l10.016.493v.324l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#373352'
        fillRule='evenodd'
        d='M20.108 67.092l10.016.493v.324l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#373352'
        fillRule='evenodd'
        d='M20.108 66.876l10.016.493v.324L20.108 67.2v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#373352'
        fillRule='evenodd'
        d='M20.108 66.66l10.016.493v.324l-10.016-.493v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#373352'
        fillRule='evenodd'
        d='M20.108 66.443l10.016.494v.324l-10.016-.493v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#373352'
        fillRule='evenodd'
        d='M20.108 66.227l10.016.494v.324l-10.016-.493v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#383352'
        fillRule='evenodd'
        d='M20.108 66.011l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#383353'
        fillRule='evenodd'
        d='M20.108 65.795l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#383354'
        fillRule='evenodd'
        d='M20.108 65.58l10.016.493v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#383354'
        fillRule='evenodd'
        d='M20.108 65.363l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#383354'
        fillRule='evenodd'
        d='M20.108 65.147l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#383354'
        fillRule='evenodd'
        d='M20.108 64.931l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#383354'
        fillRule='evenodd'
        d='M20.108 64.715l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#393455'
        fillRule='evenodd'
        d='M20.108 64.5l10.016.493v.324l-10.016-.494V64.5z'
        clipRule='evenodd'></path>
      <path
        fill='#3A3455'
        fillRule='evenodd'
        d='M20.108 64.283l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3A3455'
        fillRule='evenodd'
        d='M20.108 64.067l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3A3455'
        fillRule='evenodd'
        d='M20.108 63.851l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3A3455'
        fillRule='evenodd'
        d='M20.108 63.635l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3A3455'
        fillRule='evenodd'
        d='M20.108 63.42l10.016.493v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3A3455'
        fillRule='evenodd'
        d='M20.108 63.203l10.016.493v.325l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3C3456'
        fillRule='evenodd'
        d='M20.108 62.987l10.016.493v.325l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3C3456'
        fillRule='evenodd'
        d='M20.108 62.771l10.016.493v.325l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3C3456'
        fillRule='evenodd'
        d='M20.108 62.555l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3C3456'
        fillRule='evenodd'
        d='M20.108 62.339l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3C3456'
        fillRule='evenodd'
        d='M20.108 62.123l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3C3557'
        fillRule='evenodd'
        d='M20.108 61.907l10.016.494v.323l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3C3557'
        fillRule='evenodd'
        d='M20.108 61.69l10.016.494v.324l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3C3557'
        fillRule='evenodd'
        d='M20.108 61.475l10.016.493v.324L20.108 61.8v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3D3557'
        fillRule='evenodd'
        d='M20.108 61.259l10.016.493v.324l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3D3558'
        fillRule='evenodd'
        d='M20.108 61.042l10.016.494v.324l-10.016-.493v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#3D3558'
        fillRule='evenodd'
        d='M20.108 60.826l10.016.494v.324l-10.016-.493v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#3D3558'
        fillRule='evenodd'
        d='M20.108 60.61l10.016.494v.324l-10.016-.493v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#3E3559'
        fillRule='evenodd'
        d='M20.108 60.394l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3E3559'
        fillRule='evenodd'
        d='M20.108 60.178l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3F3559'
        fillRule='evenodd'
        d='M20.108 59.962l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3F3559'
        fillRule='evenodd'
        d='M20.108 59.746l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#3F3559'
        fillRule='evenodd'
        d='M20.108 59.53l10.016.494v.324l-10.016-.494v-.323z'
        clipRule='evenodd'></path>
      <path
        fill='#40355A'
        fillRule='evenodd'
        d='M20.108 59.315l10.016.493v.324l-10.016-.494v-.323z'
        clipRule='evenodd'></path>
      <path
        fill='#40355A'
        fillRule='evenodd'
        d='M20.108 59.098l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#40355A'
        fillRule='evenodd'
        d='M20.108 58.882l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#40355A'
        fillRule='evenodd'
        d='M20.108 58.666l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#40355A'
        fillRule='evenodd'
        d='M20.108 58.45l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#41355A'
        fillRule='evenodd'
        d='M20.108 58.234l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#41355B'
        fillRule='evenodd'
        d='M20.108 58.018l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#42365C'
        fillRule='evenodd'
        d='M20.108 57.802l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#42365C'
        fillRule='evenodd'
        d='M20.108 57.586l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#42365C'
        fillRule='evenodd'
        d='M20.108 57.37l10.016.494v.324l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#43365C'
        fillRule='evenodd'
        d='M20.108 57.154l10.016.493v.325l-10.016-.494v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#43365C'
        fillRule='evenodd'
        d='M20.108 56.938l10.016.494v.323l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#43365D'
        fillRule='evenodd'
        d='M20.108 56.722l10.016.493v.324l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#43365D'
        fillRule='evenodd'
        d='M20.108 56.506l10.016.493v.324l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#43365D'
        fillRule='evenodd'
        d='M20.108 56.29l10.016.493v.324l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#43355D'
        fillRule='evenodd'
        d='M20.108 56.074l10.016.493v.324l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#43355D'
        fillRule='evenodd'
        d='M20.108 55.858l10.016.493v.324l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#43355D'
        fillRule='evenodd'
        d='M20.108 55.642l12.583.62h-2.567v.197l-10.016-.493v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#43355D'
        fillRule='evenodd'
        d='M20.108 55.425l16.97.837h-6.577l-10.393-.513v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#46365E'
        fillRule='evenodd'
        d='M20.108 55.21l21.354 1.052h-6.577l-14.777-.729v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#46365E'
        fillRule='evenodd'
        d='M20.108 54.993l22.218 1.095v.173h-3.058l-19.16-.944v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#46355E'
        fillRule='evenodd'
        d='M20.108 54.778l22.218 1.094v.324l-22.218-1.094v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#46355E'
        fillRule='evenodd'
        d='M20.108 54.561l22.218 1.095v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#46355E'
        fillRule='evenodd'
        d='M20.108 54.345l22.218 1.095v.324L20.108 54.67v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#47355E'
        fillRule='evenodd'
        d='M20.108 54.13l22.218 1.094v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#47355E'
        fillRule='evenodd'
        d='M20.108 53.913l22.218 1.095v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#47365F'
        fillRule='evenodd'
        d='M20.108 53.697l22.218 1.095v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#47365F'
        fillRule='evenodd'
        d='M20.108 53.481l22.218 1.095v.324l-22.218-1.094v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#47365F'
        fillRule='evenodd'
        d='M20.108 53.265l22.218 1.095v.324L20.108 53.59v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#473660'
        fillRule='evenodd'
        d='M20.108 53.05l22.218 1.094v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#473660'
        fillRule='evenodd'
        d='M20.108 52.833l22.218 1.095v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#483661'
        fillRule='evenodd'
        d='M20.108 52.617l22.218 1.095v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#493661'
        fillRule='evenodd'
        d='M20.108 52.401l22.218 1.095v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#493661'
        fillRule='evenodd'
        d='M20.108 52.185l22.218 1.095v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#493661'
        fillRule='evenodd'
        d='M20.108 51.969l22.218 1.095v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#493661'
        fillRule='evenodd'
        d='M20.108 51.753l22.218 1.094v.325l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#493661'
        fillRule='evenodd'
        d='M20.108 51.537l22.218 1.095v.324L20.108 51.86v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#493661'
        fillRule='evenodd'
        d='M20.108 51.32l22.218 1.096v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4A3762'
        fillRule='evenodd'
        d='M20.108 51.105l22.218 1.094v.325l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4A3762'
        fillRule='evenodd'
        d='M20.108 50.889l22.218 1.094v.325l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4B3662'
        fillRule='evenodd'
        d='M20.108 50.673l22.218 1.094v.325l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4B3662'
        fillRule='evenodd'
        d='M20.108 50.456l22.218 1.095v.324l-22.218-1.094v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#4B3662'
        fillRule='evenodd'
        d='M20.108 50.24l22.218 1.095v.324l-22.218-1.094v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4C3764'
        fillRule='evenodd'
        d='M20.108 50.025l22.218 1.094v.324L20.108 50.35v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4C3764'
        fillRule='evenodd'
        d='M20.108 49.809l22.218 1.094v.324l-22.218-1.095v-.323z'
        clipRule='evenodd'></path>
      <path
        fill='#4C3764'
        fillRule='evenodd'
        d='M20.108 49.592l22.218 1.095v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4D3764'
        fillRule='evenodd'
        d='M20.108 49.376l22.218 1.095v.324L20.108 49.7v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4D3764'
        fillRule='evenodd'
        d='M20.108 49.16l22.218 1.095v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4D3764'
        fillRule='evenodd'
        d='M20.108 48.944l22.218 1.095v.324L20.108 49.27v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#4D3764'
        fillRule='evenodd'
        d='M20.108 48.729l22.218 1.094v.324l-22.218-1.094v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4E3765'
        fillRule='evenodd'
        d='M20.108 48.513l22.218 1.094v.324l-22.218-1.094v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#4E3765'
        fillRule='evenodd'
        d='M20.108 48.296l22.218 1.095v.324L20.108 48.62v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4E3765'
        fillRule='evenodd'
        d='M20.108 48.08l22.218 1.095v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4E3765'
        fillRule='evenodd'
        d='M20.108 47.864l9.807.483v.117h2.374l10.037.495v.324l-22.218-1.095v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4F3866'
        fillRule='evenodd'
        d='M20.108 47.648l9.807.483v.325l-9.807-.484v-.324zm16.568.817l5.65.278v.324L30.1 48.465h6.577z'
        clipRule='evenodd'></path>
      <path
        fill='#4F3866'
        fillRule='evenodd'
        d='M20.108 47.432l9.807.483v.325l-9.807-.484v-.324zm20.951 1.033l1.267.062v.324l-7.844-.386h6.577z'
        clipRule='evenodd'></path>
      <path
        fill='#4F3866'
        fillRule='evenodd'
        d='M20.108 47.216l9.807.483v.324l-9.807-.483v-.324zm22.218 1.42l-3.46-.172h3.46v.171z'
        clipRule='evenodd'></path>
      <path
        fill='#4F3767'
        fillRule='evenodd'
        d='M20.108 47l9.807.483v.325l-9.807-.484V47z'
        clipRule='evenodd'></path>
      <path
        fill='#4F3767'
        fillRule='evenodd'
        d='M20.108 46.784l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#4F3767'
        fillRule='evenodd'
        d='M20.108 46.568l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#513767'
        fillRule='evenodd'
        d='M20.108 46.352l9.807.483v.325l-9.807-.484v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#513767'
        fillRule='evenodd'
        d='M20.108 46.136l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#523868'
        fillRule='evenodd'
        d='M20.108 45.92l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#523868'
        fillRule='evenodd'
        d='M20.108 45.704l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#523868'
        fillRule='evenodd'
        d='M20.108 45.488l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#523868'
        fillRule='evenodd'
        d='M20.108 45.272l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#523869'
        fillRule='evenodd'
        d='M20.108 45.056l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#523869'
        fillRule='evenodd'
        d='M20.108 44.84l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#543869'
        fillRule='evenodd'
        d='M20.108 44.624l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#543869'
        fillRule='evenodd'
        d='M20.108 44.407l9.807.484v.324l-9.807-.483v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#543869'
        fillRule='evenodd'
        d='M20.108 44.191l9.807.484v.324l-9.807-.483v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#543869'
        fillRule='evenodd'
        d='M20.108 43.975l9.807.484v.324l-9.807-.483v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#543769'
        fillRule='evenodd'
        d='M20.108 43.76l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#56386A'
        fillRule='evenodd'
        d='M20.108 43.544l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#56386A'
        fillRule='evenodd'
        d='M20.108 43.327l9.807.484v.324l-9.807-.483v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#56386A'
        fillRule='evenodd'
        d='M20.108 43.111l9.807.484v.324l-9.807-.484v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#56386A'
        fillRule='evenodd'
        d='M20.108 42.896l9.807.483v.324l-9.807-.484v-.323z'
        clipRule='evenodd'></path>
      <path
        fill='#56386A'
        fillRule='evenodd'
        d='M20.108 42.68l9.807.483v.324l-9.807-.484v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#57386B'
        fillRule='evenodd'
        d='M20.108 42.463l9.807.484v.324l-9.807-.484v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#57386B'
        fillRule='evenodd'
        d='M20.108 42.247l9.807.483v.325l-9.807-.484v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#57386C'
        fillRule='evenodd'
        d='M20.108 42.031l9.807.483v.325l-9.807-.484v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#57386C'
        fillRule='evenodd'
        d='M20.108 41.815l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#58386C'
        fillRule='evenodd'
        d='M20.108 41.6l9.807.482v.325l-9.807-.484V41.6z'
        clipRule='evenodd'></path>
      <path
        fill='#58386C'
        fillRule='evenodd'
        d='M20.108 41.383l9.807.483v.325l-9.807-.484v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#58386C'
        fillRule='evenodd'
        d='M20.108 41.167l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#59386D'
        fillRule='evenodd'
        d='M20.108 40.95l9.807.484v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#59386D'
        fillRule='evenodd'
        d='M20.108 40.735l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5A386D'
        fillRule='evenodd'
        d='M20.108 40.519l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5A386D'
        fillRule='evenodd'
        d='M20.108 40.303l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5A386D'
        fillRule='evenodd'
        d='M20.108 40.087l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5A386D'
        fillRule='evenodd'
        d='M20.108 39.87l9.807.484v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5A386D'
        fillRule='evenodd'
        d='M20.108 39.655l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5B396E'
        fillRule='evenodd'
        d='M20.108 39.439l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5B396E'
        fillRule='evenodd'
        d='M20.108 39.223l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5B396F'
        fillRule='evenodd'
        d='M20.108 39.007l9.807.483v.324l-9.807-.483v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#5C396F'
        fillRule='evenodd'
        d='M20.108 38.79l9.807.484v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5D3970'
        fillRule='evenodd'
        d='M20.108 38.575l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5D3970'
        fillRule='evenodd'
        d='M20.108 38.359l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5D3971'
        fillRule='evenodd'
        d='M20.108 38.142l9.807.484v.324l-9.807-.483v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#5D3971'
        fillRule='evenodd'
        d='M20.108 37.927l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5D3971'
        fillRule='evenodd'
        d='M20.108 37.71l9.807.484v.324l-9.807-.484v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5E3971'
        fillRule='evenodd'
        d='M20.108 37.495l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5F3971'
        fillRule='evenodd'
        d='M20.108 37.278l9.807.484v.324l-9.807-.483v-.325z'
        clipRule='evenodd'></path>
      <path
        fill='#5F3971'
        fillRule='evenodd'
        d='M20.108 37.062l9.807.483v.325l-9.807-.484v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#5F3971'
        fillRule='evenodd'
        d='M20.108 36.846l9.807.484v.324l-9.807-.484v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#613A73'
        fillRule='evenodd'
        d='M20.108 36.63l9.807.483v.325l-9.807-.484v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#613872'
        fillRule='evenodd'
        d='M20.108 36.414l9.807.484v.323l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#613872'
        fillRule='evenodd'
        d='M20.108 36.198l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#613872'
        fillRule='evenodd'
        d='M20.108 35.982l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#613873'
        fillRule='evenodd'
        d='M20.108 35.766l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#613873'
        fillRule='evenodd'
        d='M20.108 35.55l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#623974'
        fillRule='evenodd'
        d='M20.108 35.334l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#633874'
        fillRule='evenodd'
        d='M20.108 35.118l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#633874'
        fillRule='evenodd'
        d='M20.108 34.902l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#633874'
        fillRule='evenodd'
        d='M20.108 34.686l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#643975'
        fillRule='evenodd'
        d='M20.108 34.47l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#663976'
        fillRule='evenodd'
        d='M20.108 34.254l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#663976'
        fillRule='evenodd'
        d='M20.108 34.038l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#663976'
        fillRule='evenodd'
        d='M20.108 33.822l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#663976'
        fillRule='evenodd'
        d='M20.108 33.606l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#673977'
        fillRule='evenodd'
        d='M20.108 33.39l9.807.483v.324l-9.807-.483v-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#673977'
        fillRule='evenodd'
        d='M20.111 33.174l9.804.483v.324l-9.807-.483v-.108c0-.073.003-.144.003-.216z'
        clipRule='evenodd'></path>
      <path
        fill='#673977'
        fillRule='evenodd'
        d='M20.115 32.958l9.8.483v.324l-9.806-.483.006-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#683977'
        fillRule='evenodd'
        d='M20.118 32.742l9.8.483c-.002.087-.003.175-.003.264v.06l-9.802-.483c.002-.108.002-.217.005-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#683978'
        fillRule='evenodd'
        d='M20.125 32.526l9.797.483a19.13 19.13 0 00-.006.324l-9.8-.483c.003-.108.005-.217.01-.324z'
        clipRule='evenodd'></path>
      <path
        fill='#683978'
        fillRule='evenodd'
        d='M20.135 32.31l9.795.483c-.005.107-.008.215-.01.324l-9.8-.483c.004-.108.01-.215.015-.323z'
        clipRule='evenodd'></path>
      <path
        fill='#683978'
        fillRule='evenodd'
        d='M20.146 32.096l9.794.482c-.006.107-.011.214-.015.323l-9.795-.483.016-.322z'
        clipRule='evenodd'></path>
      <path
        fill='#6A3979'
        fillRule='evenodd'
        d='M20.157 31.88l9.796.482c-.007.107-.014.215-.019.324l-9.793-.483.016-.323z'
        clipRule='evenodd'></path>
      <path
        fill='#6A3979'
        fillRule='evenodd'
        d='M20.175 31.665l9.794.482c-.009.107-.016.215-.023.323l-9.795-.482c.007-.109.015-.216.024-.323z'
        clipRule='evenodd'></path>
      <path
        fill='#6A3979'
        fillRule='evenodd'
        d='M20.192 31.45l9.797.482c-.01.107-.02.214-.028.323l-9.795-.483.026-.322z'
        clipRule='evenodd'></path>
      <path
        fill='#6B397A'
        fillRule='evenodd'
        d='M20.21 31.234l9.802.483a13.4 13.4 0 00-.033.322l-9.796-.482c.009-.108.016-.216.026-.323z'
        clipRule='evenodd'></path>
      <path
        fill='#6B397A'
        fillRule='evenodd'
        d='M20.233 31.02l9.806.482c-.015.107-.027.214-.039.323l-9.8-.483c.01-.108.021-.216.033-.323z'
        clipRule='evenodd'></path>
      <path
        fill='#6B397A'
        fillRule='evenodd'
        d='M20.257 30.804l9.812.484c-.016.106-.031.213-.045.322l-9.803-.483c.01-.109.024-.215.036-.323z'
        clipRule='evenodd'></path>
      <path
        fill='#6D397A'
        fillRule='evenodd'
        d='M20.281 30.59l9.821.483-.05.322-9.807-.483c.012-.108.023-.216.036-.323z'
        clipRule='evenodd'></path>
      <path
        fill='#6D397A'
        fillRule='evenodd'
        d='M20.31 30.375l9.83.484c-.02.106-.038.213-.055.322l-9.816-.484c.013-.108.027-.215.042-.322z'
        clipRule='evenodd'></path>
      <path
        fill='#6D397B'
        fillRule='evenodd'
        d='M20.342 30.16l9.84.485c-.022.106-.042.213-.061.321l-9.826-.484c.014-.108.031-.214.047-.322z'
        clipRule='evenodd'></path>
      <path
        fill='#6D397B'
        fillRule='evenodd'
        d='M20.374 29.946l9.854.485a11 11 0 00-.067.321l-9.835-.484c.016-.108.03-.216.048-.322z'
        clipRule='evenodd'></path>
      <path
        fill='#6D397B'
        fillRule='evenodd'
        d='M20.41 29.732l9.869.486c-.026.105-.05.212-.074.32l-9.847-.485c.017-.107.033-.215.052-.321z'
        clipRule='evenodd'></path>
      <path
        fill='#6F3A7D'
        fillRule='evenodd'
        d='M20.508 29.264l9.907.488c-.031.105-.06.212-.089.32l-9.877-.487c.02-.107.038-.215.06-.321z'
        clipRule='evenodd'></path>
      <path
        fill='#6F3A7D'
        fillRule='evenodd'
        d='M20.53 29.09l9.93.489a9.906 9.906 0 00-.096.319l-9.896-.488c.02-.107.04-.214.062-.32z'
        clipRule='evenodd'></path>
      <path
        fill='#6F3A7D'
        fillRule='evenodd'
        d='M20.577 28.876l9.955.49c-.037.105-.072.211-.105.32l-9.92-.49c.022-.108.047-.213.07-.32z'
        clipRule='evenodd'></path>
      <path
        fill='#6F3A7D'
        fillRule='evenodd'
        d='M20.624 28.662l9.985.492a8.91 8.91 0 00-.114.319l-9.942-.49.07-.321z'
        clipRule='evenodd'></path>
      <path
        fill='#6F3A7D'
        fillRule='evenodd'
        d='M20.674 28.449l10.018.493c-.043.105-.083.21-.123.318l-9.968-.49c.024-.108.047-.215.073-.321z'
        clipRule='evenodd'></path>
      <path
        fill='#713A7D'
        fillRule='evenodd'
        d='M20.729 28.235l10.053.496c-.046.104-.09.21-.133.317l-10.002-.492c.026-.108.054-.214.082-.32z'
        clipRule='evenodd'></path>
      <path
        fill='#723A7E'
        fillRule='evenodd'
        d='M20.783 28.022l10.095.497a8.56 8.56 0 00-.142.318l-10.035-.495c.026-.107.054-.214.082-.32z'
        clipRule='evenodd'></path>
      <path
        fill='#723A7E'
        fillRule='evenodd'
        d='M20.841 27.809l10.142.5c-.053.103-.104.209-.154.316l-10.073-.496c.028-.107.055-.215.085-.32z'
        clipRule='evenodd'></path>
      <path
        fill='#723A7E'
        fillRule='evenodd'
        d='M20.904 27.596l10.192.502a7.476 7.476 0 00-.166.316l-10.12-.499c.03-.107.063-.213.094-.32z'
        clipRule='evenodd'></path>
      <path
        fill='#743A7F'
        fillRule='evenodd'
        d='M20.967 27.383l10.25.505a7.47 7.47 0 00-.178.315l-10.166-.5c.03-.108.062-.215.094-.32z'
        clipRule='evenodd'></path>
      <path
        fill='#743A80'
        fillRule='evenodd'
        d='M21.035 27.17l10.313.508c-.067.103-.13.208-.193.315l-10.22-.504c.033-.107.065-.213.1-.319z'
        clipRule='evenodd'></path>
      <path
        fill='#743A80'
        fillRule='evenodd'
        d='M21.106 26.958l10.382.511c-.071.103-.14.207-.207.314l-10.282-.506c.034-.108.071-.213.107-.32z'
        clipRule='evenodd'></path>
      <path
        fill='#743980'
        fillRule='evenodd'
        d='M21.177 26.745l10.463.516a6.853 6.853 0 00-.224.313l-10.346-.51c.035-.107.07-.213.107-.319z'
        clipRule='evenodd'></path>
      <path
        fill='#743980'
        fillRule='evenodd'
        d='M21.254 26.533l10.55.52a6.678 6.678 0 00-.24.312l-10.422-.513c.036-.107.074-.214.112-.319z'
        clipRule='evenodd'></path>
      <path
        fill='#743980'
        fillRule='evenodd'
        d='M21.335 26.32l10.648.525c-.09.101-.177.205-.262.312l-10.507-.518c.039-.108.08-.213.12-.318z'
        clipRule='evenodd'></path>
      <path
        fill='#743A81'
        fillRule='evenodd'
        d='M21.415 26.109l10.76.53c-.098.1-.192.203-.284.31l-10.597-.522c.04-.106.079-.214.12-.318z'
        clipRule='evenodd'></path>
      <path
        fill='#763980'
        fillRule='evenodd'
        d='M21.503 25.897l10.882.536c-.106.1-.209.203-.308.31l-10.703-.528c.042-.107.085-.213.129-.318z'
        clipRule='evenodd'></path>
      <path
        fill='#763981'
        fillRule='evenodd'
        d='M21.592 25.685l11.02.543a6.59 6.59 0 00-.334.308l-10.82-.533c.044-.107.089-.213.134-.318z'
        clipRule='evenodd'></path>
      <path
        fill='#763981'
        fillRule='evenodd'
        d='M21.683 25.474l11.181.55c-.126.098-.25.2-.368.307l-10.949-.54c.045-.106.09-.213.136-.317zm24.81 1.222l.147.007-.03.075-.117-.082z'
        clipRule='evenodd'></path>
      <path
        fill='#773A83'
        fillRule='evenodd'
        d='M21.781 25.263l11.359.56c-.14.096-.274.197-.405.303l-11.099-.547c.047-.107.097-.211.145-.316zm24.364 1.2l.584.029-.12.285a13.022 13.022 0 00-.464-.314z'
        clipRule='evenodd'></path>
      <path
        fill='#773A83'
        fillRule='evenodd'
        d='M21.88 25.051l11.565.57a6.949 6.949 0 00-.446.302l-11.267-.555c.049-.106.097-.212.148-.317zm23.888 1.177l1.05.052-.133.317-.363-.017c-.18-.121-.365-.238-.554-.352z'
        clipRule='evenodd'></path>
      <path
        fill='#773A83'
        fillRule='evenodd'
        d='M21.984 24.84l11.803.582a7.16 7.16 0 00-.499.3l-11.458-.565c.05-.106.101-.212.154-.317zm23.374 1.152l1.55.077-.134.317-.814-.04c-.197-.123-.397-.24-.602-.354z'
        clipRule='evenodd'></path>
      <path
        fill='#783A83'
        fillRule='evenodd'
        d='M22.092 24.63l12.082.595a7.38 7.38 0 00-.563.296l-11.681-.575c.052-.107.107-.211.162-.316zm22.814 1.124l2.09.103-.133.317-1.295-.064a13.343 13.343 0 00-.662-.356z'
        clipRule='evenodd'></path>
      <path
        fill='#783A83'
        fillRule='evenodd'
        d='M22.2 24.42l12.421.611c-.223.09-.439.187-.646.292l-11.937-.588c.054-.105.106-.212.162-.316zm22.203 1.093l2.682.132-.133.318-1.814-.09a13.55 13.55 0 00-.735-.36z'
        clipRule='evenodd'></path>
      <path
        fill='#793A84'
        fillRule='evenodd'
        d='M22.318 24.209l12.829.632a8.39 8.39 0 00-.757.287l-12.244-.604c.056-.106.114-.21.172-.315zm21.512 1.06l3.344.165-.134.317-2.378-.117c-.271-.13-.549-.252-.832-.365z'
        clipRule='evenodd'></path>
      <path
        fill='#793A84'
        fillRule='evenodd'
        d='M22.437 23.998l13.354.659c-.32.079-.625.172-.918.279l-12.614-.622c.058-.106.117-.211.178-.316zm20.717 1.021l4.108.203-.133.317-3.002-.148a13.62 13.62 0 00-.973-.371z'
        clipRule='evenodd'></path>
      <path
        fill='#793A84'
        fillRule='evenodd'
        d='M22.56 23.789l14.08.694c-.415.068-.812.156-1.19.265l-13.073-.644c.06-.106.121-.211.183-.315zm19.742.973l5.05.248-.134.318-3.71-.183a13.636 13.636 0 00-1.206-.383z'
        clipRule='evenodd'></path>
      <path
        fill='#7B3A84'
        fillRule='evenodd'
        d='M22.69 23.579l15.326.755c-.65.037-1.262.115-1.835.234l-13.685-.675c.063-.106.128-.21.193-.314zm18.304.902l6.446.318-.133.317-4.55-.224c-.57-.174-1.16-.313-1.763-.411z'
        clipRule='evenodd'></path>
      <path
        fill='#7B3A86'
        fillRule='evenodd'
        d='M22.82 23.37l24.71 1.217-.134.318-5.647-.279a13.17 13.17 0 00-2.86-.316c-.588 0-1.146.032-1.677.093l-14.587-.719c.064-.105.128-.211.194-.315z'
        clipRule='evenodd'></path>
      <path
        fill='#7B3A86'
        fillRule='evenodd'
        d='M22.959 23.16l24.659 1.216-.133.317-24.732-1.219c.068-.106.137-.21.206-.314z'
        clipRule='evenodd'></path>
      <path
        fill='#7B3A86'
        fillRule='evenodd'
        d='M23.099 22.951l24.608 1.213-.133.317-24.685-1.216c.07-.106.138-.21.21-.314z'
        clipRule='evenodd'></path>
      <path
        fill='#7B3A86'
        fillRule='evenodd'
        d='M23.248 22.743l24.548 1.21-.133.317-24.634-1.214c.072-.106.145-.21.219-.313z'
        clipRule='evenodd'></path>
      <path
        fill='#7B3A87'
        fillRule='evenodd'
        d='M23.399 22.534l24.486 1.206-.134.318-24.58-1.211c.075-.106.151-.21.228-.313z'
        clipRule='evenodd'></path>
      <path
        fill='#7C3A87'
        fillRule='evenodd'
        d='M23.557 22.326l24.417 1.203-.134.317-24.517-1.208c.077-.105.155-.21.234-.312z'
        clipRule='evenodd'></path>
      <path
        fill='#7E3B88'
        fillRule='evenodd'
        d='M23.72 22.118l24.343 1.2-.134.316-24.454-1.204c.08-.106.163-.209.245-.312z'
        clipRule='evenodd'></path>
      <path
        fill='#7E3B88'
        fillRule='evenodd'
        d='M23.887 21.91l24.264 1.195-.133.318-24.38-1.201c.082-.105.165-.21.25-.312z'
        clipRule='evenodd'></path>
      <path
        fill='#7E3B88'
        fillRule='evenodd'
        d='M24.064 21.703l24.176 1.19-.133.318-24.305-1.197c.085-.106.174-.209.262-.311z'
        clipRule='evenodd'></path>
      <path
        fill='#7E3B89'
        fillRule='evenodd'
        d='M24.243 21.495l24.086 1.187-.133.317-24.22-1.193c.088-.105.176-.209.267-.31z'
        clipRule='evenodd'></path>
      <path
        fill='#803B89'
        fillRule='evenodd'
        d='M24.433 21.289l23.985 1.181-.133.318-24.133-1.19c.092-.104.186-.207.281-.31z'
        clipRule='evenodd'></path>
      <path
        fill='#803B8A'
        fillRule='evenodd'
        d='M24.625 21.082l23.882 1.177-.133.317-24.036-1.184c.095-.104.19-.209.287-.31z'
        clipRule='evenodd'></path>
      <path
        fill='#803B8A'
        fillRule='evenodd'
        d='M24.83 20.876l23.766 1.17-.133.318-23.935-1.179c.099-.105.2-.207.301-.31z'
        clipRule='evenodd'></path>
      <path
        fill='#803B8A'
        fillRule='evenodd'
        d='M25.036 20.67l23.649 1.165-.134.318-23.824-1.174c.102-.104.204-.208.31-.309z'
        clipRule='evenodd'></path>
      <path
        fill='#803989'
        fillRule='evenodd'
        d='M25.256 20.465l23.518 1.159-.134.317-23.709-1.168c.107-.105.215-.207.325-.308z'
        clipRule='evenodd'></path>
      <path
        fill='#82398B'
        fillRule='evenodd'
        d='M25.48 20.26l23.383 1.152-.134.318-23.583-1.163c.11-.104.221-.207.334-.307z'
        clipRule='evenodd'></path>
      <path
        fill='#83398B'
        fillRule='evenodd'
        d='M25.716 20.055L48.952 21.2l-.134.318-23.452-1.156c.115-.104.232-.206.35-.306z'
        clipRule='evenodd'></path>
      <path
        fill='#83398B'
        fillRule='evenodd'
        d='M25.96 19.851l23.08 1.138-.133.317-23.309-1.148c.12-.104.24-.207.362-.307z'
        clipRule='evenodd'></path>
      <path
        fill='#83398B'
        fillRule='evenodd'
        d='M26.214 19.648l22.915 1.13-.133.316-23.162-1.14c.125-.105.252-.206.38-.306z'
        clipRule='evenodd'></path>
      <path
        fill='#83398B'
        fillRule='evenodd'
        d='M26.48 19.445l22.738 1.12-.133.318-22.998-1.133c.13-.104.26-.206.394-.305z'
        clipRule='evenodd'></path>
      <path
        fill='#84398B'
        fillRule='evenodd'
        d='M26.753 19.242l22.554 1.112-.133.317-22.83-1.125c.135-.103.271-.205.41-.304z'
        clipRule='evenodd'></path>
      <path
        fill='#85398C'
        fillRule='evenodd'
        d='M27.047 19.04l22.349 1.102-.134.317-22.645-1.115c.141-.104.284-.205.43-.303z'
        clipRule='evenodd'></path>
      <path
        fill='#85398E'
        fillRule='evenodd'
        d='M27.349 18.84l22.136 1.09-.134.318L26.9 19.142c.148-.103.297-.204.449-.302z'
        clipRule='evenodd'></path>
      <path
        fill='#85398E'
        fillRule='evenodd'
        d='M27.665 18.64l21.909 1.079-.134.317-22.247-1.096c.155-.103.313-.203.472-.3z'
        clipRule='evenodd'></path>
      <path
        fill='#863A8F'
        fillRule='evenodd'
        d='M28.003 18.44l21.5 1.06.132.073-.106.252-22.022-1.085c.163-.103.328-.203.496-.3z'
        clipRule='evenodd'></path>
      <path
        fill='#863A8F'
        fillRule='evenodd'
        d='M28.355 18.241l20.722 1.021c.187.102.373.204.558.31l-.017.041-21.786-1.073c.173-.103.347-.202.523-.299z'
        clipRule='evenodd'></path>
      <path
        fill='#863A8F'
        fillRule='evenodd'
        d='M28.724 18.044l19.904.98c.221.116.442.235.662.357l-21.117-1.04c.182-.103.365-.202.551-.297z'
        clipRule='evenodd'></path>
      <path
        fill='#883A8F'
        fillRule='evenodd'
        d='M29.122 17.847l19.038.938c.232.116.464.236.696.359l-20.317-1.002c.192-.102.386-.2.583-.295z'
        clipRule='evenodd'></path>
      <path
        fill='#883A8F'
        fillRule='evenodd'
        d='M29.547 17.652l18.121.893c.244.116.489.236.732.36l-19.476-.96c.205-.102.412-.2.623-.293z'
        clipRule='evenodd'></path>
      <path
        fill='#883A90'
        fillRule='evenodd'
        d='M30 17.458l17.141.845c.259.116.517.237.774.362l-18.585-.916c.22-.102.444-.198.67-.29z'
        clipRule='evenodd'></path>
      <path
        fill='#893A91'
        fillRule='evenodd'
        d='M30.487 17.266l16.092.793c.276.116.551.238.826.365l-17.641-.87c.238-.101.48-.196.723-.288z'
        clipRule='evenodd'></path>
      <path
        fill='#8A3A91'
        fillRule='evenodd'
        d='M31.02 17.076l14.954.737c.297.117.594.24.89.368l-16.63-.82c.259-.1.52-.195.785-.285z'
        clipRule='evenodd'></path>
      <path
        fill='#8A3A91'
        fillRule='evenodd'
        d='M31.606 16.889l13.71.676c.323.117.646.24.968.371l-15.539-.765c.284-.101.57-.195.861-.282z'
        clipRule='evenodd'></path>
      <path
        fill='#8A3A92'
        fillRule='evenodd'
        d='M32.263 16.705l12.328.608c.355.117.71.242 1.066.377l-14.355-.708c.316-.1.637-.192.961-.277z'
        clipRule='evenodd'></path>
      <path
        fill='#8C3A93'
        fillRule='evenodd'
        d='M33.013 16.526l10.76.53c.397.117.795.245 1.193.383l-13.048-.642c.36-.101.726-.191 1.095-.27z'
        clipRule='evenodd'></path>
      <path
        fill='#8C3A93'
        fillRule='evenodd'
        d='M33.922 16.355l8.867.437c.467.116.934.247 1.401.393l-11.568-.57c.427-.101.86-.188 1.3-.26z'
        clipRule='evenodd'></path>
      <path
        fill='#8C3A93'
        fillRule='evenodd'
        d='M43.303 16.925l-9.857-.486c3.076-.586 6.45-.441 9.857.486z'
        clipRule='evenodd'></path>
      <path
        fill='#C33539'
        fillRule='evenodd'
        d='M13.668 70.885l4.908.336c-1.387.153-3.095.048-4.908-.336z'
        clipRule='evenodd'></path>
      <path
        fill='#C33539'
        fillRule='evenodd'
        d='M12.141 70.502l6.65.456v.239c-.4.053-.83.083-1.284.09l-2.587-.177a20.724 20.724 0 01-2.779-.608z'
        clipRule='evenodd'></path>
      <path
        fill='#C43839'
        fillRule='evenodd'
        d='M11.03 70.147l7.761.532v.418l-5.967-.41a21.727 21.727 0 01-1.794-.54z'
        clipRule='evenodd'></path>
      <path
        fill='#C43839'
        fillRule='evenodd'
        d='M10.123 69.806l8.668.594v.418l-7.239-.496a21.572 21.572 0 01-1.43-.516z'
        clipRule='evenodd'></path>
      <path
        fill='#C43839'
        fillRule='evenodd'
        d='M9.34 69.474l9.451.648v.417l-8.234-.564c-.408-.153-.814-.32-1.218-.5z'
        clipRule='evenodd'></path>
      <path
        fill='#C43839'
        fillRule='evenodd'
        d='M8.646 69.148l10.145.695v.418L9.72 69.64a21.05 21.05 0 01-1.073-.492z'
        clipRule='evenodd'></path>
      <path
        fill='#C43A39'
        fillRule='evenodd'
        d='M8.019 68.827l10.772.737v.418L8.98 69.31a20.38 20.38 0 01-.961-.483z'
        clipRule='evenodd'></path>
      <path
        fill='#C43A39'
        fillRule='evenodd'
        d='M7.45 68.509l11.341.777v.418l-10.465-.717c-.295-.152-.587-.31-.876-.478z'
        clipRule='evenodd'></path>
      <path
        fill='#C43A39'
        fillRule='evenodd'
        d='M6.93 68.195l11.861.813v.417l-11.06-.757c-.27-.152-.538-.309-.802-.473z'
        clipRule='evenodd'></path>
      <path
        fill='#C43A39'
        fillRule='evenodd'
        d='M6.447 67.883l12.344.846v.418l-11.604-.795c-.25-.15-.497-.307-.74-.469z'
        clipRule='evenodd'></path>
      <path
        fill='#C53939'
        fillRule='evenodd'
        d='M5.998 67.574l12.793.876v.418l-12.106-.83c-.232-.149-.461-.304-.687-.464z'
        clipRule='evenodd'></path>
      <path
        fill='#C53939'
        fillRule='evenodd'
        d='M5.58 67.266l13.211.906v.417L6.22 67.73c-.216-.15-.43-.304-.64-.463z'
        clipRule='evenodd'></path>
      <path
        fill='#C63C39'
        fillRule='evenodd'
        d='M5.187 66.961l13.604.932v.418l-13.004-.89c-.203-.15-.404-.302-.6-.46z'
        clipRule='evenodd'></path>
      <path
        fill='#C63C39'
        fillRule='evenodd'
        d='M4.823 66.658l13.968.956v.418l-13.408-.918c-.19-.148-.377-.3-.56-.456z'
        clipRule='evenodd'></path>
      <path
        fill='#C63C39'
        fillRule='evenodd'
        d='M4.48 66.356l14.311.98v.418l-13.786-.945a15.838 15.838 0 01-.525-.453z'
        clipRule='evenodd'></path>
      <path
        fill='#C63C39'
        fillRule='evenodd'
        d='M4.157 66.055l14.634 1.002v.418L4.65 66.506c-.167-.146-.33-.297-.492-.451z'
        clipRule='evenodd'></path>
      <path
        fill='#C63E39'
        fillRule='evenodd'
        d='M3.852 65.755l14.94 1.024v.418l-14.479-.992c-.157-.147-.31-.297-.461-.45z'
        clipRule='evenodd'></path>
      <path
        fill='#C63E39'
        fillRule='evenodd'
        d='M3.564 65.457L18.79 66.5v.418l-14.79-1.013a15.01 15.01 0 01-.437-.448z'
        clipRule='evenodd'></path>
      <path
        fill='#C63E39'
        fillRule='evenodd'
        d='M3.296 65.16l15.495 1.061v.418L3.708 65.606c-.14-.145-.278-.294-.412-.446z'
        clipRule='evenodd'></path>
      <path
        fill='#C63E39'
        fillRule='evenodd'
        d='M3.041 64.864l15.75 1.079v.418L3.43 65.308a14.456 14.456 0 01-.388-.444z'
        clipRule='evenodd'></path>
      <path
        fill='#C63E39'
        fillRule='evenodd'
        d='M2.798 64.569l15.993 1.095v.418l-15.628-1.07a14.1 14.1 0 01-.365-.443z'
        clipRule='evenodd'></path>
      <path
        fill='#C64039'
        fillRule='evenodd'
        d='M2.575 64.275l16.216 1.11v.419L2.92 64.716a14.147 14.147 0 01-.344-.441z'
        clipRule='evenodd'></path>
      <path
        fill='#C64039'
        fillRule='evenodd'
        d='M2.361 63.982l16.43 1.125v.418L2.686 64.422c-.11-.144-.22-.291-.325-.44z'
        clipRule='evenodd'></path>
      <path
        fill='#C64039'
        fillRule='evenodd'
        d='M2.158 63.69l16.633 1.139v.418L2.463 64.128c-.104-.144-.206-.29-.305-.439z'
        clipRule='evenodd'></path>
      <path
        fill='#C64039'
        fillRule='evenodd'
        d='M1.971 63.398l16.82 1.152v.418L2.26 63.836c-.1-.144-.195-.29-.289-.438z'
        clipRule='evenodd'></path>
      <path
        fill='#C64039'
        fillRule='evenodd'
        d='M1.791 63.107l17 1.164v.418L2.063 63.543a13.478 13.478 0 01-.272-.436z'
        clipRule='evenodd'></path>
      <path
        fill='#C64039'
        fillRule='evenodd'
        d='M1.625 62.817l17.166 1.176v.418L1.88 63.252a12.896 12.896 0 01-.254-.435z'
        clipRule='evenodd'></path>
      <path
        fill='#C64239'
        fillRule='evenodd'
        d='M1.468 62.528l17.323 1.186v.418l-17.083-1.17a12.417 12.417 0 01-.24-.434z'
        clipRule='evenodd'></path>
      <path
        fill='#C64239'
        fillRule='evenodd'
        d='M1.32 62.239l17.471 1.197v.417l-17.25-1.181c-.076-.142-.15-.287-.222-.433z'
        clipRule='evenodd'></path>
      <path
        fill='#C64239'
        fillRule='evenodd'
        d='M1.183 61.951l17.608 1.206v.418L1.393 62.383a12.483 12.483 0 01-.21-.432z'
        clipRule='evenodd'></path>
      <path
        fill='#C64239'
        fillRule='evenodd'
        d='M1.051 61.663l17.74 1.216v.418L1.25 62.095a13.095 13.095 0 01-.198-.432z'
        clipRule='evenodd'></path>
      <path
        fill='#C74439'
        fillRule='evenodd'
        d='M.934 61.377L18.791 62.6v.418L1.117 61.807a12.374 12.374 0 01-.183-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#C74439'
        fillRule='evenodd'
        d='M.82 61.09l17.971 1.231v.418L.991 61.52c-.059-.142-.117-.284-.172-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#C74439'
        fillRule='evenodd'
        d='M.72 60.805l18.071 1.238v.418L.877 61.234a12.834 12.834 0 01-.158-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#C74439'
        fillRule='evenodd'
        d='M.62 60.52l18.171 1.244v.418L.77 60.948a12.785 12.785 0 01-.149-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#C74439'
        fillRule='evenodd'
        d='M.536 60.235l18.255 1.25v.418L.67 60.663c-.047-.141-.091-.284-.134-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#C74439'
        fillRule='evenodd'
        d='M.452 59.95l18.34 1.257v.418L.577 60.377a12.238 12.238 0 01-.126-.426z'
        clipRule='evenodd'></path>
      <path
        fill='#C94639'
        fillRule='evenodd'
        d='M.383 59.667l18.408 1.261v.419L.494 60.093c-.04-.14-.076-.282-.111-.426z'
        clipRule='evenodd'></path>
      <path
        fill='#C94639'
        fillRule='evenodd'
        d='M.313 59.384l18.478 1.266v.418L.417 59.809c-.036-.14-.072-.281-.104-.425z'
        clipRule='evenodd'></path>
      <path
        fill='#C94639'
        fillRule='evenodd'
        d='M.257 59.102l18.534 1.27v.417L.348 59.526c-.033-.14-.063-.282-.091-.424z'
        clipRule='evenodd'></path>
      <path
        fill='#C94839'
        fillRule='evenodd'
        d='M.202 58.82l18.59 1.273v.418L.283 59.243c-.029-.14-.057-.28-.082-.424z'
        clipRule='evenodd'></path>
      <path
        fill='#C94839'
        fillRule='evenodd'
        d='M.158 58.538l18.633 1.276v.418L.23 58.961c-.027-.14-.05-.281-.072-.423z'
        clipRule='evenodd'></path>
      <path
        fill='#C94839'
        fillRule='evenodd'
        d='M.117 58.256l18.674 1.28v.417L.178 58.678c-.023-.139-.042-.28-.06-.422z'
        clipRule='evenodd'></path>
      <path
        fill='#C94839'
        fillRule='evenodd'
        d='M.083 57.975l18.708 1.282v.418L.137 58.397c-.02-.14-.038-.28-.054-.422z'
        clipRule='evenodd'></path>
      <path
        fill='#C94839'
        fillRule='evenodd'
        d='M.056 57.695l18.735 1.283v.418L.097 58.116c-.017-.139-.028-.28-.04-.421z'
        clipRule='evenodd'></path>
      <path
        fill='#CB4839'
        fillRule='evenodd'
        d='M.032 57.415l18.76 1.285v.418L.07 57.835c-.014-.14-.028-.278-.038-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#CB4939'
        fillRule='evenodd'
        d='M.018 57.135l18.773 1.286v.418L.043 57.555c-.011-.138-.018-.279-.025-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#CB4939'
        fillRule='evenodd'
        d='M.005 56.856l18.786 1.287v.417L.025 57.275c-.008-.139-.016-.278-.02-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#CB4939'
        fillRule='evenodd'
        d='M.002 56.577l18.79 1.287v.418L.011 56.996a14.572 14.572 0 01-.01-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#CB4939'
        fillRule='evenodd'
        d='M0 56.298l18.791 1.288v.417L.002 56.716a14.665 14.665 0 01-.001-.418z'
        clipRule='evenodd'></path>
      <path
        fill='#CB4C39'
        fillRule='evenodd'
        d='M.005 56.02l18.786 1.287v.418L.001 56.438c0-.139 0-.277.004-.418z'
        clipRule='evenodd'></path>
      <path
        fill='#CB4C39'
        fillRule='evenodd'
        d='M.018 55.742l18.773 1.286v.418L.001 56.16c.002-.137.01-.277.017-.417z'
        clipRule='evenodd'></path>
      <path
        fill='#CB4C39'
        fillRule='evenodd'
        d='M.03 55.465L18.79 56.75v.418L.011 55.88c.006-.139.01-.276.018-.416z'
        clipRule='evenodd'></path>
      <path
        fill='#CB4C39'
        fillRule='evenodd'
        d='M.053 55.188L18.79 56.47v.418L.023 55.604c.008-.138.019-.277.03-.416z'
        clipRule='evenodd'></path>
      <path
        fill='#CB4C39'
        fillRule='evenodd'
        d='M.077 54.91l18.714 1.282v.419L.041 55.326c.01-.137.023-.276.036-.415z'
        clipRule='evenodd'></path>
      <path
        fill='#CB4C39'
        fillRule='evenodd'
        d='M.106 54.634l18.685 1.28v.418L.065 55.049c.012-.138.025-.275.04-.415z'
        clipRule='evenodd'></path>
      <path
        fill='#CC4E39'
        fillRule='evenodd'
        d='M.142 54.358l5.78.396c.628.287 1.349.368 2.133.146l10.736.736v.417L.09 54.773c.015-.138.035-.277.053-.415z'
        clipRule='evenodd'></path>
      <path
        fill='#CC4E39'
        fillRule='evenodd'
        d='M.179 54.082l5.2.356c.31.221.653.389 1.02.488l-6.275-.43c.017-.138.034-.275.055-.414zm8.502.582l10.11.693v.418l-11.249-.77a3.704 3.704 0 001.139-.34z'
        clipRule='evenodd'></path>
      <path
        fill='#CC4E39'
        fillRule='evenodd'
        d='M.224 53.806l4.78.328c.19.175.395.33.613.46L.16 54.22c.02-.137.04-.275.064-.413zm8.91.61l9.657.662v.418l-10.39-.712c.227-.087.457-.2.692-.34.015-.009.027-.019.041-.027z'
        clipRule='evenodd'></path>
      <path
        fill='#CC4F39'
        fillRule='evenodd'
        d='M.272 53.531l4.439.304c.145.164.301.314.467.45L.2 53.944c.021-.136.047-.275.072-.413zm9.237.633l9.282.636v.418l-9.87-.677a4.791 4.791 0 00.588-.378z'
        clipRule='evenodd'></path>
      <path
        fill='#CC4F39'
        fillRule='evenodd'
        d='M.32 53.256l4.15.284c.118.157.244.306.38.444l-4.602-.315c.024-.138.045-.274.073-.413zm9.504.651l8.967.614v.418l-9.466-.648c.178-.121.348-.247.5-.384z'
        clipRule='evenodd'></path>
      <path
        fill='#CC4F39'
        fillRule='evenodd'
        d='M.38 52.981l3.887.267c.099.153.205.3.318.44l-4.289-.294c.026-.137.055-.275.084-.413zm9.704.665l8.707.596v.419l-9.124-.626c.15-.123.29-.252.417-.389z'
        clipRule='evenodd'></path>
      <path
        fill='#CC4F39'
        fillRule='evenodd'
        d='M.44 52.707l3.654.25c.083.15.173.297.27.437L.35 53.119c.028-.137.059-.274.09-.412zm9.863.675l8.488.582v.418l-8.837-.606c.126-.125.243-.256.35-.394z'
        clipRule='evenodd'></path>
      <path
        fill='#CC4F39'
        fillRule='evenodd'
        d='M.503 52.433l3.442.236c.07.148.148.293.231.433L.41 52.844c.03-.137.06-.273.093-.411zm9.988.684l8.3.569v.417l-8.593-.589a3.96 3.96 0 00.293-.397z'
        clipRule='evenodd'></path>
      <path
        fill='#CC4F39'
        fillRule='evenodd'
        d='M.574 52.159l3.244.222c.06.147.126.291.199.432L.47 52.57c.032-.136.069-.274.104-.411zm10.077.69l8.14.558v.418l-8.385-.575a4.01 4.01 0 00.245-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#CC5139'
        fillRule='evenodd'
        d='M.645 51.885l3.064.21c.05.146.107.289.17.43l-3.34-.23c.033-.136.068-.272.106-.41zm10.14.695l8.006.548v.418l-8.215-.563c.077-.13.147-.264.21-.403z'
        clipRule='evenodd'></path>
      <path
        fill='#CD5139'
        fillRule='evenodd'
        d='M.72 51.612l2.899.198c.041.145.089.287.142.428L.61 52.022c.036-.136.072-.273.112-.41zm10.172.696l7.9.541v.419l-8.074-.554c.065-.131.123-.266.174-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5239'
        fillRule='evenodd'
        d='M.803 51.339l2.741.188c.034.143.073.285.118.426L.68 51.748c.038-.135.082-.272.123-.409zm10.18.697l7.808.535v.418l-7.95-.545c.053-.132.1-.268.142-.408z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5239'
        fillRule='evenodd'
        d='M.885 51.066l2.601.178c.026.142.057.284.094.424l-2.818-.193c.04-.136.08-.272.123-.41zm10.174.697l7.732.53v.417l-7.847-.537c.044-.134.082-.27.114-.41z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5439'
        fillRule='evenodd'
        d='M.973 50.793l2.47.17c.017.14.041.282.07.422l-2.67-.183c.043-.136.085-.272.13-.409zm10.138.695l7.68.526v.418l-7.77-.533a5.13 5.13 0 00.09-.411z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5439'
        fillRule='evenodd'
        d='M1.066 50.521l2.348.161.014.15c.01.09.02.181.034.271L.926 50.93c.044-.134.093-.272.14-.408zm10.089.691l7.636.523v.418l-7.705-.528c.027-.135.05-.272.069-.413z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5439'
        fillRule='evenodd'
        d='M1.159 50.249l2.23.152c.011.137.024.277.038.421l-2.408-.165c.046-.135.091-.27.14-.408zm10.026.687l7.606.52v.419l-7.654-.525c.02-.135.036-.274.048-.414z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5439'
        fillRule='evenodd'
        d='M1.258 49.977l2.109.145c.01.135.02.275.034.42l-2.289-.157c.048-.135.095-.271.146-.408zm9.942.681l7.591.52v.418l-7.621-.522a6.79 6.79 0 00.03-.416z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5439'
        fillRule='evenodd'
        d='M1.361 49.706l1.987.136c.008.135.018.275.03.42l-2.172-.15c.049-.134.103-.27.155-.406zm9.85.674l7.58.52v.417l-7.596-.52c.009-.137.014-.275.015-.417z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5439'
        fillRule='evenodd'
        d='M1.465 49.434l1.868.128.024.42-2.047-.14c.05-.136.1-.271.155-.408zm9.74.667l7.586.52v.418l-7.585-.52a8.11 8.11 0 00-.001-.418z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5639'
        fillRule='evenodd'
        d='M1.574 49.163l1.749.12c.004.134.01.274.017.419l-1.927-.132c.053-.135.105-.27.16-.407zm9.62.659l7.597.52v.419l-7.584-.52a8.664 8.664 0 00-.013-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5639'
        fillRule='evenodd'
        d='M1.688 48.892l1.628.112c.002.134.006.273.012.418l-1.811-.124c.054-.134.114-.27.17-.406zm9.485.65l7.618.522v.417l-7.59-.52a9.952 9.952 0 00-.028-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5639'
        fillRule='evenodd'
        d='M1.802 48.622l1.512.103c0 .134.001.273.005.418l-1.688-.115.17-.406zm9.342.64l7.647.523v.418l-7.608-.521c-.01-.139-.023-.279-.039-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5639'
        fillRule='evenodd'
        d='M1.92 48.35l1.397.096c-.002.134-.003.273-.002.418l-1.57-.107c.057-.135.114-.27.175-.406zm9.19.63l7.681.527v.418l-7.63-.523a11.91 11.91 0 00-.051-.422z'
        clipRule='evenodd'></path>
      <path
        fill='#CF5639'
        fillRule='evenodd'
        d='M2.044 48.081l1.282.088c-.005.133-.009.271-.01.417l-1.457-.1c.059-.134.123-.27.185-.405zm9.023.618l7.724.53v.417l-7.664-.525c-.017-.14-.037-.28-.06-.422z'
        clipRule='evenodd'></path>
      <path
        fill='#D15739'
        fillRule='evenodd'
        d='M2.168 47.81l1.172.081c-.008.132-.014.271-.019.417l-1.34-.092.187-.405zm8.853.607l7.77.533v.417l-7.7-.527a13.7 13.7 0 00-.07-.423z'
        clipRule='evenodd'></path>
      <path
        fill='#D15739'
        fillRule='evenodd'
        d='M2.294 47.54l1.067.074c-.011.131-.021.27-.029.416l-1.226-.084c.063-.135.123-.269.188-.405zm8.671.595l7.826.536v.418l-7.747-.531c-.024-.14-.05-.28-.079-.423z'
        clipRule='evenodd'></path>
      <path
        fill='#D15739'
        fillRule='evenodd'
        d='M2.429 47.272l.959.065c-.014.131-.027.27-.038.416l-1.12-.077c.064-.134.132-.27.199-.404zm8.479.58l7.883.54v.418l-7.797-.534c-.027-.14-.055-.28-.086-.424z'
        clipRule='evenodd'></path>
      <path
        fill='#D15739'
        fillRule='evenodd'
        d='M2.563 47.002l.858.059c-.017.13-.033.269-.047.414l-1.012-.069c.065-.134.133-.268.201-.404zm8.28.567l7.948.545v.418l-7.854-.539c-.03-.14-.061-.28-.095-.424z'
        clipRule='evenodd'></path>
      <path
        fill='#D15A39'
        fillRule='evenodd'
        d='M2.698 46.733l.763.052c-.02.13-.04.268-.057.414l-.908-.062c.067-.135.131-.269.202-.404zm8.078.553l8.015.549v.418l-7.915-.542c-.032-.14-.064-.282-.1-.425z'
        clipRule='evenodd'></path>
      <path
        fill='#D15A39'
        fillRule='evenodd'
        d='M2.841 46.464l.665.046c-.022.13-.044.268-.065.413l-.81-.056c.068-.133.139-.268.21-.403zm7.86.538l8.09.555v.417l-7.982-.546c-.034-.14-.07-.283-.107-.425z'
        clipRule='evenodd'></path>
      <path
        fill='#D15A39'
        fillRule='evenodd'
        d='M2.985 46.195l.57.04a27.25 27.25 0 00-.072.412l-.714-.049c.07-.133.144-.268.216-.403zm7.641.524l8.165.559v.418l-8.052-.552c-.036-.14-.073-.282-.113-.425z'
        clipRule='evenodd'></path>
      <path
        fill='#D15A39'
        fillRule='evenodd'
        d='M3.13 45.927l.473.032-.073.413-.617-.042c.072-.134.142-.268.217-.403zm7.415.508l8.246.564v.418l-8.127-.556c-.038-.141-.078-.283-.12-.426z'
        clipRule='evenodd'></path>
      <path
        fill='#D15A39'
        fillRule='evenodd'
        d='M3.28 45.658l.368.026c-.02.135-.044.271-.07.413l-.52-.036a33.9 33.9 0 01.222-.403zm7.182.492l8.33.57v.419l-8.206-.562c-.04-.142-.08-.283-.124-.427z'
        clipRule='evenodd'></path>
      <path
        fill='#D15A39'
        fillRule='evenodd'
        d='M3.434 45.39l.252.018a8.241 8.241 0 01-.06.413l-.424-.029c.074-.132.155-.268.232-.402zm6.94.476l8.417.576v.418l-8.288-.567a28.57 28.57 0 00-.129-.427z'
        clipRule='evenodd'></path>
      <path
        fill='#D15B39'
        fillRule='evenodd'
        d='M3.588 45.122l.123.009c-.01.14-.024.277-.043.415l-.311-.022.23-.402zm6.697.459l8.506.583v.417l-8.372-.573a33.17 33.17 0 00-.134-.427z'
        clipRule='evenodd'></path>
      <path
        fill='#D15B39'
        fillRule='evenodd'
        d='M10.192 45.296l8.6.589v.418l-8.462-.58c-.045-.141-.09-.284-.138-.427zM3.7 45.269l-.19-.013c.071-.121.138-.242.21-.365-.001.13-.009.255-.02.378z'
        clipRule='evenodd'></path>
      <path
        fill='#D15B39'
        fillRule='evenodd'
        d='M10.097 45.01l8.694.596v.418l-8.552-.585a38.224 38.224 0 00-.142-.428zm-6.38-.018l-.052-.004.055-.097-.002.101z'
        clipRule='evenodd'></path>
      <path
        fill='#D15B39'
        fillRule='evenodd'
        d='M10 44.726l8.791.602v.418l-8.647-.593a40.45 40.45 0 00-.145-.427z'
        clipRule='evenodd'></path>
      <path
        fill='#D15D39'
        fillRule='evenodd'
        d='M9.9 44.44l8.891.61v.417l-8.742-.599c-.048-.141-.1-.284-.15-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#D15D39'
        fillRule='evenodd'
        d='M9.798 44.155l8.993.616v.418l-8.842-.606-.151-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#D15D39'
        fillRule='evenodd'
        d='M9.694 43.869l9.097.623v.418l-8.942-.613-.155-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#D15D39'
        fillRule='evenodd'
        d='M9.59 43.583l9.201.63v.419l-9.045-.62c-.052-.143-.103-.285-.157-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#D15D39'
        fillRule='evenodd'
        d='M9.482 43.297l9.31.638v.418l-9.15-.627a67.613 67.613 0 00-.16-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#D25F39'
        fillRule='evenodd'
        d='M9.374 43.011l9.417.645v.418l-9.255-.634-.162-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#D25F39'
        fillRule='evenodd'
        d='M9.264 42.725l9.527.653v.418l-9.363-.642-.164-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#D35F38'
        fillRule='evenodd'
        d='M9.154 42.44l9.637.66v.417l-9.472-.649-.165-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#D35F38'
        fillRule='evenodd'
        d='M9.042 42.153l9.75.668v.418l-9.583-.657-.167-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D36138'
        fillRule='evenodd'
        d='M8.93 41.867l9.861.675v.418l-9.693-.664-.169-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D36138'
        fillRule='evenodd'
        d='M8.816 41.58l9.975.684v.417l-9.806-.671-.169-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D36138'
        fillRule='evenodd'
        d='M8.702 41.294l10.09.691v.418l-9.92-.68-.17-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D36138'
        fillRule='evenodd'
        d='M8.588 41.007l10.203.7v.417L8.76 41.437l-.171-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D36138'
        fillRule='evenodd'
        d='M8.472 40.721l10.32.707v.418L8.644 41.15l-.173-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D36138'
        fillRule='evenodd'
        d='M8.357 40.434l10.434.715v.418L8.53 40.864l-.173-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D36238'
        fillRule='evenodd'
        d='M8.241 40.148l10.55.723v.417l-10.377-.71-.173-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D36238'
        fillRule='evenodd'
        d='M8.126 39.862l10.665.73v.418L8.3 40.29l-.173-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D36238'
        fillRule='evenodd'
        d='M8.01 39.575l10.781.739v.417l-10.608-.726-.173-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D66339'
        fillRule='evenodd'
        d='M7.894 39.288l10.897.747v.418l-10.723-.735-.174-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D66539'
        fillRule='evenodd'
        d='M7.778 39.002l11.013.754v.418l-10.84-.742-.173-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D86538'
        fillRule='evenodd'
        d='M7.663 38.715l11.128.763v.417l-10.955-.75-.173-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D86538'
        fillRule='evenodd'
        d='M7.548 38.429l11.243.77v.418l-11.07-.758-.173-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D86538'
        fillRule='evenodd'
        d='M7.433 38.142l11.358.778v.419l-11.186-.767-.172-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D86538'
        fillRule='evenodd'
        d='M7.32 37.856l11.471.786v.417l-11.3-.773-.171-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D86538'
        fillRule='evenodd'
        d='M7.206 37.57l11.585.793v.418L7.376 38l-.17-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D86738'
        fillRule='evenodd'
        d='M7.093 37.284l11.698.8v.419l-11.529-.79-.169-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D86738'
        fillRule='evenodd'
        d='M6.98 36.997l11.811.81v.417L7.15 37.427l-.168-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D86738'
        fillRule='evenodd'
        d='M6.87 36.711l11.921.817v.418L7.037 37.14l-.166-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#D86738'
        fillRule='evenodd'
        d='M6.76 36.425l12.031.824v.418l-11.865-.813-.166-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D86738'
        fillRule='evenodd'
        d='M6.65 36.139l12.141.831v.419l-11.976-.821-.164-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D86838'
        fillRule='evenodd'
        d='M6.543 35.853l12.248.839v.418l-12.086-.828-.162-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#D86838'
        fillRule='evenodd'
        d='M6.436 35.567l12.355.846v.418l-12.194-.835-.161-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D86838'
        fillRule='evenodd'
        d='M6.331 35.281l12.46.854v.418L6.49 35.71l-.158-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#D86838'
        fillRule='evenodd'
        d='M6.226 34.995l12.565.861v.418l-12.407-.85-.158-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#D86A38'
        fillRule='evenodd'
        d='M6.125 34.71l12.666.868v.417L6.28 35.138l-.154-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#D86A38'
        fillRule='evenodd'
        d='M6.023 34.424l12.768.875v.418l-12.616-.864-.152-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#D86A38'
        fillRule='evenodd'
        d='M5.924 34.139l12.867.881v.418l-12.717-.871-.15-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#D86A38'
        fillRule='evenodd'
        d='M5.827 33.854l12.964.888v.418l-12.818-.878c-.05-.143-.098-.285-.146-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#D86A38'
        fillRule='evenodd'
        d='M5.73 33.569l13.061.894v.418l-12.916-.884-.145-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#D86A38'
        fillRule='evenodd'
        d='M5.638 33.284l13.153.9v.419L5.778 33.71a45.985 45.985 0 01-.14-.427z'
        clipRule='evenodd'></path>
      <path
        fill='#D86C38'
        fillRule='evenodd'
        d='M5.545 32.999l13.246.907v.418l-13.107-.898A54.687 54.687 0 015.545 33z'
        clipRule='evenodd'></path>
      <path
        fill='#DA6C38'
        fillRule='evenodd'
        d='M5.456 32.714l13.335.914v.417l-13.2-.904a41.629 41.629 0 01-.135-.427z'
        clipRule='evenodd'></path>
      <path
        fill='#DA6C38'
        fillRule='evenodd'
        d='M5.37 32.43l13.421.919v.418L5.5 32.857l-.13-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#DA6C38'
        fillRule='evenodd'
        d='M5.283 32.145l13.51.925a24.22 24.22 0 00-.002.32v.098l-13.378-.916c-.044-.143-.088-.285-.13-.427z'
        clipRule='evenodd'></path>
      <path
        fill='#DA6E38'
        fillRule='evenodd'
        d='M5.202 31.861l13.596.931a24.04 24.04 0 00-.006.418l-13.466-.923c-.043-.142-.084-.284-.124-.426z'
        clipRule='evenodd'></path>
      <path
        fill='#DA6E38'
        fillRule='evenodd'
        d='M5.12 31.576l13.687.938c-.005.138-.008.278-.011.417l-13.553-.928a33.006 33.006 0 01-.122-.427z'
        clipRule='evenodd'></path>
      <path
        fill='#DA6E38'
        fillRule='evenodd'
        d='M5.044 31.293l13.774.944c-.006.138-.011.277-.015.416L5.16 31.72l-.117-.426z'
        clipRule='evenodd'></path>
      <path
        fill='#DA6E38'
        fillRule='evenodd'
        d='M4.97 31.01l13.863.949c-.008.138-.015.277-.02.416l-13.731-.94c-.04-.142-.076-.284-.112-.426z'
        clipRule='evenodd'></path>
      <path
        fill='#DA6E38'
        fillRule='evenodd'
        d='M4.897 30.726l13.954.956c-.01.137-.018.276-.026.415l-13.818-.946c-.037-.142-.075-.284-.11-.425z'
        clipRule='evenodd'></path>
      <path
        fill='#DB6F38'
        fillRule='evenodd'
        d='M4.83 30.442l14.042.962c-.012.138-.022.277-.03.416l-13.91-.953c-.036-.142-.069-.283-.102-.425z'
        clipRule='evenodd'></path>
      <path
        fill='#DB6F38'
        fillRule='evenodd'
        d='M4.762 30.16l14.134.968a22.82 22.82 0 00-.035.415l-13.997-.959c-.035-.142-.07-.283-.102-.425z'
        clipRule='evenodd'></path>
      <path
        fill='#DB6F38'
        fillRule='evenodd'
        d='M4.702 29.877l14.222.974c-.014.137-.028.276-.04.415L4.795 30.3a26.6 26.6 0 01-.094-.424z'
        clipRule='evenodd'></path>
      <path
        fill='#DB7138'
        fillRule='evenodd'
        d='M4.642 29.594l14.313.98c-.016.138-.032.276-.046.415l-14.177-.971a24.442 24.442 0 01-.09-.424z'
        clipRule='evenodd'></path>
      <path
        fill='#DB7138'
        fillRule='evenodd'
        d='M4.587 29.312l14.403.986a21.62 21.62 0 00-.05.415l-14.268-.978c-.03-.141-.059-.283-.085-.423z'
        clipRule='evenodd'></path>
      <path
        fill='#DC7138'
        fillRule='evenodd'
        d='M4.535 29.03l14.494.992c-.02.138-.04.275-.057.414l-14.36-.983c-.027-.142-.052-.283-.077-.424z'
        clipRule='evenodd'></path>
      <path
        fill='#DC7138'
        fillRule='evenodd'
        d='M4.485 28.747l14.586 1c-.022.136-.043.274-.062.413L4.56 29.17c-.026-.14-.053-.282-.076-.423z'
        clipRule='evenodd'></path>
      <path
        fill='#DC7138'
        fillRule='evenodd'
        d='M4.443 28.466l14.673 1.005a22.87 22.87 0 00-.067.413l-14.54-.996c-.024-.141-.045-.282-.066-.422z'
        clipRule='evenodd'></path>
      <path
        fill='#DC7338'
        fillRule='evenodd'
        d='M4.4 28.185l14.766 1.01c-.026.137-.05.275-.073.414L4.464 28.607c-.022-.141-.044-.282-.063-.422z'
        clipRule='evenodd'></path>
      <path
        fill='#DC7338'
        fillRule='evenodd'
        d='M4.367 27.904l14.852 1.017-.079.412-14.718-1.008c-.02-.14-.038-.281-.055-.421z'
        clipRule='evenodd'></path>
      <path
        fill='#DC7338'
        fillRule='evenodd'
        d='M4.334 27.623l14.942 1.023c-.03.137-.058.274-.084.412L4.383 28.044a17.47 17.47 0 01-.049-.421z'
        clipRule='evenodd'></path>
      <path
        fill='#DE7538'
        fillRule='evenodd'
        d='M4.307 27.342l15.03 1.03c-.031.136-.061.273-.09.412L4.35 27.762c-.016-.14-.03-.281-.043-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#DE7538'
        fillRule='evenodd'
        d='M4.285 27.062l15.117 1.036a19.74 19.74 0 00-.096.411L4.318 27.482c-.013-.14-.023-.28-.033-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#DE7538'
        fillRule='evenodd'
        d='M4.266 26.782l6.228.427c.52.265 1.155.332 1.906.13l7.071.485c-.035.136-.07.273-.102.41L4.296 27.203c-.011-.14-.022-.28-.03-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#DE7538'
        fillRule='evenodd'
        d='M4.256 26.503l5.779.396c.261.226.565.39.909.48l-6.67-.457c-.009-.14-.013-.28-.018-.419zm8.8.603l6.489.444c-.038.136-.074.273-.11.411l-7.578-.52a4.031 4.031 0 001.2-.335z'
        clipRule='evenodd'></path>
      <path
        fill='#DE7738'
        fillRule='evenodd'
        d='M4.245 26.224l5.496.376c.147.174.311.326.492.452l-5.972-.41c-.006-.14-.014-.28-.016-.418zm9.307.637l6.07.416c-.04.136-.078.272-.115.41l-6.745-.462c.252-.092.515-.212.79-.364z'
        clipRule='evenodd'></path>
      <path
        fill='#DE7738'
        fillRule='evenodd'
        d='M4.246 25.945l5.277.361c.106.162.224.31.353.443l-5.626-.386c-.004-.14-.004-.279-.004-.418zm9.726.666l5.732.393c-.041.136-.082.272-.122.41l-6.265-.43c.211-.105.43-.229.655-.373z'
        clipRule='evenodd'></path>
      <path
        fill='#DE7738'
        fillRule='evenodd'
        d='M4.248 25.667l5.104.35c.082.155.173.301.273.436l-5.38-.368c0-.14 0-.28.003-.418zm10.097.691l5.446.373c-.044.136-.087.272-.128.41l-5.894-.404c.137-.082.277-.171.42-.269.053-.036.104-.073.155-.11z'
        clipRule='evenodd'></path>
      <path
        fill='#DE7938'
        fillRule='evenodd'
        d='M4.26 25.389l4.955.34c.065.151.138.296.218.432l-5.186-.355c.002-.14.006-.279.013-.417zm10.43.714l5.192.356a18.26 18.26 0 00-.135.409l-5.584-.383.026-.017c.176-.12.342-.242.502-.365z'
        clipRule='evenodd'></path>
      <path
        fill='#DE7938'
        fillRule='evenodd'
        d='M4.275 25.111l4.83.331c.052.15.11.293.175.43l-5.028-.344c.005-.14.013-.278.023-.416zm10.736.736l4.966.34c-.049.135-.096.27-.141.408l-5.312-.364c.17-.126.332-.255.487-.384z'
        clipRule='evenodd'></path>
      <path
        fill='#DE7938'
        fillRule='evenodd'
        d='M4.297 24.834l4.717.323c.042.148.09.29.143.428l-4.89-.335c.008-.14.018-.278.03-.416zm11.01.755l4.77.326c-.05.135-.1.271-.148.408l-5.073-.347c.159-.128.309-.257.452-.387z'
        clipRule='evenodd'></path>
      <path
        fill='#E17937'
        fillRule='evenodd'
        d='M4.327 24.558l4.616.316c.033.146.071.288.114.426l-4.774-.327c.011-.14.028-.277.044-.415zm11.254.77l4.602.316c-.054.135-.106.27-.156.407l-4.863-.333c.146-.128.285-.258.417-.39z'
        clipRule='evenodd'></path>
      <path
        fill='#E17B37'
        fillRule='evenodd'
        d='M4.361 24.282l4.526.31c.025.144.054.286.09.424l-4.665-.32c.015-.139.03-.277.05-.414zm11.472.785l4.46.306c-.055.134-.11.27-.163.407l-4.682-.321c.135-.13.263-.26.385-.392z'
        clipRule='evenodd'></path>
      <path
        fill='#E17B37'
        fillRule='evenodd'
        d='M4.406 24.006l4.438.304c.018.144.042.285.07.423l-4.572-.314c.018-.139.041-.276.064-.413zm11.658.799l4.345.297c-.059.134-.116.27-.172.406l-4.527-.31c.124-.13.243-.26.354-.393z'
        clipRule='evenodd'></path>
      <path
        fill='#E17B37'
        fillRule='evenodd'
        d='M4.454 23.73l4.36.3c.013.142.03.283.05.42l-4.48-.306c.021-.138.043-.277.07-.413zm11.82.81l4.256.292c-.062.134-.122.269-.18.405l-4.4-.3c.115-.132.224-.264.325-.397z'
        clipRule='evenodd'></path>
      <path
        fill='#E17B37'
        fillRule='evenodd'
        d='M4.516 23.456l4.28.294c.007.142.017.282.032.42l-4.4-.302c.026-.138.057-.275.088-.412zm11.951.82l4.189.286c-.064.134-.127.269-.188.405l-4.297-.294c.105-.132.204-.264.296-.398z'
        clipRule='evenodd'></path>
      <path
        fill='#E17B37'
        fillRule='evenodd'
        d='M4.578 23.182l4.211.289c.001.141.006.28.015.419l-4.32-.296c.03-.138.06-.276.094-.412zm12.064.827l4.145.284c-.067.133-.132.268-.195.404l-4.22-.289c.096-.132.187-.265.27-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#E17C37'
        fillRule='evenodd'
        d='M4.658 22.91l4.134.282c-.004.14-.004.28 0 .418l-4.245-.29c.033-.139.072-.275.111-.41zm12.142.83l4.125.283c-.07.134-.138.268-.204.404l-4.165-.285a6.53 6.53 0 00.244-.401z'
        clipRule='evenodd'></path>
      <path
        fill='#E17C37'
        fillRule='evenodd'
        d='M4.738 22.636l4.067.279c-.009.14-.014.279-.015.416l-4.172-.285c.038-.138.076-.275.12-.41zm12.203.836l4.127.283c-.072.133-.143.267-.212.403l-4.134-.283c.079-.134.152-.268.22-.403z'
        clipRule='evenodd'></path>
      <path
        fill='#E17C37'
        fillRule='evenodd'
        d='M4.836 22.364l3.992.273c-.014.14-.024.279-.03.416l-4.1-.28c.043-.138.09-.274.138-.409zm12.232.838l4.15.284c-.076.133-.15.267-.222.403l-4.124-.283c.07-.134.136-.269.195-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E17E37'
        fillRule='evenodd'
        d='M4.936 22.092l3.924.269a8.3 8.3 0 00-.045.415L4.787 22.5c.047-.137.095-.273.149-.408zm12.243.839l4.194.287c-.079.133-.156.267-.231.402l-4.137-.283c.063-.135.122-.27.174-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#E17E37'
        fillRule='evenodd'
        d='M5.054 21.822l3.848.264a8.086 8.086 0 00-.059.413l-3.957-.27a8.5 8.5 0 01.168-.407zm12.222.837l4.26.292c-.083.132-.163.266-.241.401l-4.171-.285c.055-.136.107-.272.152-.408z'
        clipRule='evenodd'></path>
      <path
        fill='#E37E37'
        fillRule='evenodd'
        d='M5.175 21.552l3.778.259a8.295 8.295 0 00-.073.412l-3.886-.266c.057-.136.116-.272.18-.405zm12.184.834l4.346.298c-.085.132-.17.265-.251.4l-4.226-.289c.048-.136.093-.272.131-.409z'
        clipRule='evenodd'></path>
      <path
        fill='#E37E37'
        fillRule='evenodd'
        d='M5.316 21.282l3.698.254a8.292 8.292 0 00-.087.412l-3.813-.262c.063-.136.131-.27.202-.404zm12.114.83l4.45.305c-.088.132-.175.265-.26.4l-4.302-.294c.042-.137.08-.273.111-.41z'
        clipRule='evenodd'></path>
      <path
        fill='#E37F37'
        fillRule='evenodd'
        d='M5.46 21.014l3.624.248a8.286 8.286 0 00-.102.411l-3.738-.256a8.38 8.38 0 01.215-.403zm12.027.824l4.577.313c-.093.132-.183.265-.273.4l-4.396-.302c.035-.136.067-.274.093-.411z'
        clipRule='evenodd'></path>
      <path
        fill='#E68137'
        fillRule='evenodd'
        d='M5.625 20.747l3.54.242a8.318 8.318 0 00-.117.41l-3.66-.25c.074-.136.154-.27.237-.402zm11.908.815l4.722.324c-.096.131-.19.264-.283.398l-4.513-.309c.03-.137.054-.275.074-.413z'
        clipRule='evenodd'></path>
      <path
        fill='#E68137'
        fillRule='evenodd'
        d='M5.794 20.48l3.462.237a7.847 7.847 0 00-.132.409L5.54 20.88c.081-.135.163-.269.253-.4zm11.774.806l4.885.335c-.1.13-.198.263-.295.397l-4.647-.318c.023-.137.042-.276.057-.414z'
        clipRule='evenodd'></path>
      <path
        fill='#E68237'
        fillRule='evenodd'
        d='M5.989 20.214l3.37.231c-.054.135-.104.27-.15.408l-3.5-.24c.089-.135.183-.267.28-.399zm11.602.795l5.07.347c-.105.13-.208.263-.308.397l-4.801-.329c.017-.138.03-.276.04-.415z'
        clipRule='evenodd'></path>
      <path
        fill='#E68237'
        fillRule='evenodd'
        d='M6.188 19.95l3.284.224-.052.119c-.04.095-.078.191-.114.288l-3.415-.234c.095-.134.192-.267.297-.398zm11.416.781l5.272.361a16 16 0 00-.32.397l-4.976-.341c.012-.139.02-.277.024-.417z'
        clipRule='evenodd'></path>
      <path
        fill='#E68237'
        fillRule='evenodd'
        d='M6.413 19.686l3.188.219a6.12 6.12 0 00-.18.388l-.008.017-3.326-.228c.103-.134.213-.265.326-.396zm11.194.767l5.493.376c-.113.13-.224.261-.333.395l-5.168-.354c.006-.139.009-.278.008-.417z'
        clipRule='evenodd'></path>
      <path
        fill='#E68237'
        fillRule='evenodd'
        d='M6.647 19.424l3.098.212a6.423 6.423 0 00-.21.404L6.3 19.817c.11-.133.225-.265.346-.394zm10.952.75l5.735.393c-.118.13-.233.26-.347.394l-5.38-.368a8.115 8.115 0 00-.008-.419z'
        clipRule='evenodd'></path>
      <path
        fill='#E68237'
        fillRule='evenodd'
        d='M6.905 19.163l3 .205a6.83 6.83 0 00-.234.402l-3.146-.215a9.41 9.41 0 01.38-.392zm10.678.731l5.995.41c-.123.13-.244.26-.362.394l-5.612-.384c-.003-.14-.01-.28-.021-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#E68437'
        fillRule='evenodd'
        d='M7.18 18.903l2.9.199c-.09.131-.175.264-.256.4l-3.048-.209c.13-.132.264-.262.404-.39zm10.378.71l6.274.43c-.128.13-.253.26-.377.393l-5.863-.402c-.008-.14-.02-.28-.034-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#E68437'
        fillRule='evenodd'
        d='M7.473 18.645l2.796.191a9.609 9.609 0 00-.278.399l-2.957-.203c.14-.131.288-.26.44-.387zm10.05.688l6.574.45c-.133.128-.264.259-.394.391l-6.132-.42a9.276 9.276 0 00-.048-.421z'
        clipRule='evenodd'></path>
      <path
        fill='#E68437'
        fillRule='evenodd'
        d='M7.797 18.388l2.672.183c-.103.132-.201.264-.296.398l-2.847-.195c.15-.131.308-.26.47-.386zm9.684.664l6.893.472c-.139.127-.276.257-.41.39l-6.423-.44c-.017-.141-.037-.282-.06-.422z'
        clipRule='evenodd'></path>
      <path
        fill='#E68637'
        fillRule='evenodd'
        d='M8.13 18.132l2.547.175c-.107.132-.21.264-.31.396l-2.736-.187c.148-.12.3-.239.46-.354l.04-.03zm9.3.637l7.234.496c-.146.127-.289.256-.43.389l-6.731-.462a10.831 10.831 0 00-.073-.423z'
        clipRule='evenodd'></path>
      <path
        fill='#E68637'
        fillRule='evenodd'
        d='M8.49 17.879l2.402.164a28.3 28.3 0 00-.32.396l-2.61-.179c.044-.032.084-.066.128-.098.124-.09.259-.185.4-.283zm8.882.608l7.594.52c-.152.127-.301.256-.449.387l-7.06-.483a11.363 11.363 0 00-.085-.424z'
        clipRule='evenodd'></path>
      <path
        fill='#E68637'
        fillRule='evenodd'
        d='M8.861 17.625l2.26.155c-.074.08-.145.16-.212.242l-.125.153-2.475-.17c.171-.12.357-.248.552-.38zm8.445.579l7.978.546c-.16.126-.316.255-.47.386l-7.412-.508c-.03-.142-.062-.283-.096-.424z'
        clipRule='evenodd'></path>
      <path
        fill='#E68637'
        fillRule='evenodd'
        d='M9.245 17.373l2.127.146c-.128.13-.253.26-.37.392l-2.328-.159c.181-.123.372-.251.57-.379zm7.989.547l8.295.569a4.343 4.343 0 01-.205.229 16.44 16.44 0 00-.201.16l-7.783-.532a13.469 13.469 0 00-.107-.426z'
        clipRule='evenodd'></path>
      <path
        fill='#E98836'
        fillRule='evenodd'
        d='M9.642 17.122l1.989.136c-.129.13-.26.26-.386.391L9.05 17.5c.19-.125.389-.252.591-.377zm7.512.514l8.577.588a3.949 3.949 0 01-.318.396l-8.142-.558a13.892 13.892 0 00-.117-.426z'
        clipRule='evenodd'></path>
      <path
        fill='#E98836'
        fillRule='evenodd'
        d='M10.057 16.872l1.826.125c-.122.13-.251.26-.382.391l-2.06-.14c.201-.128.408-.254.616-.377zm7.012.48l8.83.605a3.27 3.27 0 01-.264.4l-8.44-.578c-.04-.143-.082-.285-.126-.427z'
        clipRule='evenodd'></path>
      <path
        fill='#E98836'
        fillRule='evenodd'
        d='M10.495 16.623l1.618.11a6.242 6.242 0 01-.354.394l-1.912-.13c.214-.13.432-.255.648-.374zm6.482.444l9.05.62a2.857 2.857 0 01-.209.403l-8.706-.596a15.55 15.55 0 00-.135-.427z'
        clipRule='evenodd'></path>
      <path
        fill='#E98936'
        fillRule='evenodd'
        d='M10.966 16.377l1.341.091a3.422 3.422 0 01-.306.398l-1.728-.119c.232-.132.465-.257.693-.37zm5.914.405l9.245.633a2.52 2.52 0 01-.157.407l-8.945-.612a16.771 16.771 0 00-.143-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#E98936'
        fillRule='evenodd'
        d='M11.492 16.134l.961.066a2.11 2.11 0 01-.237.402l-1.49-.103c.26-.136.519-.26.766-.365zm5.285.362l9.406.645a2.34 2.34 0 01-.102.41l-9.152-.627c-.05-.143-.1-.286-.152-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#E98936'
        fillRule='evenodd'
        d='M12.146 15.9l.396.027c-.03.14-.083.276-.155.408l-1.167-.08a6.24 6.24 0 01.926-.355zm4.523.31l9.542.654a2.317 2.317 0 01-.053.414l-9.33-.639a19.84 19.84 0 00-.16-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#E98936'
        fillRule='evenodd'
        d='M16.556 15.924l9.647.66c.012.14.012.28-.001.418l-9.479-.649c-.054-.144-.11-.287-.167-.43zm-4.05.14l-.714-.049c.278-.102.538-.173.767-.201a1.219 1.219 0 01-.054.25z'
        clipRule='evenodd'></path>
      <path
        fill='#E98936'
        fillRule='evenodd'
        d='M16.439 15.637l9.726.666c.027.141.042.281.046.421l-9.598-.657a22.94 22.94 0 00-.174-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#E98B36'
        fillRule='evenodd'
        d='M16.317 15.35l9.778.67c.042.142.074.283.094.424l-9.692-.664c-.059-.144-.119-.287-.18-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#E98B36'
        fillRule='evenodd'
        d='M16.192 15.063l9.805.672c.056.143.102.285.136.427l-9.755-.668a31.522 31.522 0 00-.186-.431z'
        clipRule='evenodd'></path>
      <path
        fill='#E98B36'
        fillRule='evenodd'
        d='M16.064 14.776l9.807.672c.07.144.13.287.18.43l-9.796-.671a34.417 34.417 0 00-.191-.431z'
        clipRule='evenodd'></path>
      <path
        fill='#E98B36'
        fillRule='evenodd'
        d='M15.932 14.488l9.788.67c.082.146.154.29.217.433l-9.809-.671c-.064-.146-.13-.29-.196-.432z'
        clipRule='evenodd'></path>
      <path
        fill='#E98C36'
        fillRule='evenodd'
        d='M15.798 14.2l9.747.668c.093.146.179.291.254.435l-9.8-.671-.2-.432z'
        clipRule='evenodd'></path>
      <path
        fill='#E98C36'
        fillRule='evenodd'
        d='M15.662 13.913l9.687.663c.103.147.199.293.286.437l-9.77-.669a72.38 72.38 0 00-.203-.431z'
        clipRule='evenodd'></path>
      <path
        fill='#E98C36'
        fillRule='evenodd'
        d='M15.524 13.625l9.61.658c.112.147.218.294.316.44l-9.72-.666c-.068-.146-.137-.29-.206-.432z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8E36'
        fillRule='evenodd'
        d='M15.386 13.336l9.515.652c.12.148.235.295.342.441l-9.65-.66-.207-.433z'
        clipRule='evenodd'></path>
      <path
        fill='#EB8F35'
        fillRule='evenodd'
        d='M15.247 13.048l9.406.645c.128.149.251.296.367.443l-9.564-.655-.209-.433z'
        clipRule='evenodd'></path>
      <path
        fill='#EB8F35'
        fillRule='evenodd'
        d='M15.108 12.76l9.284.636c.134.15.263.297.386.444l-9.462-.648-.208-.432z'
        clipRule='evenodd'></path>
      <path
        fill='#EB8F35'
        fillRule='evenodd'
        d='M14.97 12.472l9.152.627c.139.15.273.298.402.445l-9.347-.64-.207-.432z'
        clipRule='evenodd'></path>
      <path
        fill='#EB8F35'
        fillRule='evenodd'
        d='M14.835 12.184l9.006.617c.143.15.282.3.417.447l-9.219-.632-.204-.432z'
        clipRule='evenodd'></path>
      <path
        fill='#EC9035'
        fillRule='evenodd'
        d='M14.702 11.897l8.852.606c.146.15.29.3.428.447l-9.08-.622c-.069-.147-.136-.29-.2-.431z'
        clipRule='evenodd'></path>
      <path
        fill='#ED9136'
        fillRule='evenodd'
        d='M14.573 11.61l8.69.594.436.448-8.931-.611a24.835 24.835 0 01-.195-.432z'
        clipRule='evenodd'></path>
      <path
        fill='#ED9136'
        fillRule='evenodd'
        d='M14.45 11.322l8.518.584c.15.15.296.3.44.448l-8.77-.6a17.86 17.86 0 01-.187-.432z'
        clipRule='evenodd'></path>
      <path
        fill='#EE9335'
        fillRule='evenodd'
        d='M14.335 11.036l8.336.57.445.45-8.605-.59a13.091 13.091 0 01-.176-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#EE9335'
        fillRule='evenodd'
        d='M14.23 10.75l8.145.558.444.448-8.427-.577a9.831 9.831 0 01-.161-.429z'
        clipRule='evenodd'></path>
      <path
        fill='#EE9335'
        fillRule='evenodd'
        d='M14.139 10.465l7.94.544.444.448-8.241-.564a6.829 6.829 0 01-.143-.428z'
        clipRule='evenodd'></path>
      <path
        fill='#EE9335'
        fillRule='evenodd'
        d='M14.062 10.181l7.724.53.44.448-8.043-.551a5.53 5.53 0 01-.082-.277l-.04-.15z'
        clipRule='evenodd'></path>
      <path
        fill='#F09435'
        fillRule='evenodd'
        d='M13.992 9.898l7.505.514.435.448-7.833-.537a14.833 14.833 0 01-.107-.425z'
        clipRule='evenodd'></path>
      <path
        fill='#F09435'
        fillRule='evenodd'
        d='M13.929 9.615l7.284.5.428.446-7.615-.521a15.813 15.813 0 01-.097-.425z'
        clipRule='evenodd'></path>
      <path
        fill='#F09435'
        fillRule='evenodd'
        d='M13.872 9.332l7.062.484c.14.15.28.3.42.447l-7.394-.507a14.445 14.445 0 01-.088-.424z'
        clipRule='evenodd'></path>
      <path
        fill='#F19635'
        fillRule='evenodd'
        d='M13.82 9.05l6.842.469c.136.15.273.3.41.446L13.9 9.474a14.209 14.209 0 01-.079-.424z'
        clipRule='evenodd'></path>
      <path
        fill='#F19635'
        fillRule='evenodd'
        d='M13.775 8.769l6.622.453c.132.15.266.299.4.446l-6.952-.477c-.026-.14-.05-.281-.07-.422z'
        clipRule='evenodd'></path>
      <path
        fill='#F19635'
        fillRule='evenodd'
        d='M13.736 8.487l6.404.439c.128.15.258.298.389.445l-6.732-.461a12.984 12.984 0 01-.06-.423z'
        clipRule='evenodd'></path>
      <path
        fill='#F19635'
        fillRule='evenodd'
        d='M13.703 8.207l6.188.424c.124.15.25.297.377.443l-6.513-.446c-.02-.14-.037-.281-.052-.421z'
        clipRule='evenodd'></path>
      <path
        fill='#F19635'
        fillRule='evenodd'
        d='M13.677 7.926l5.974.41c.12.149.24.296.364.442l-6.296-.43c-.016-.141-.03-.282-.042-.422z'
        clipRule='evenodd'></path>
      <path
        fill='#F19834'
        fillRule='evenodd'
        d='M13.658 7.646l5.763.395c.114.149.23.296.349.442l-6.08-.417c-.014-.14-.024-.28-.032-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#F19834'
        fillRule='evenodd'
        d='M13.644 7.367l5.555.38c.11.149.22.296.335.441l-5.867-.402c-.01-.14-.018-.28-.023-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#F19834'
        fillRule='evenodd'
        d='M13.638 7.088l5.35.366c.104.148.21.295.32.44l-5.658-.387c-.006-.14-.01-.28-.012-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#F19A34'
        fillRule='evenodd'
        d='M13.639 6.81l5.147.352c.1.148.2.294.305.439l-5.45-.374a11.2 11.2 0 01-.002-.418z'
        clipRule='evenodd'></path>
      <path
        fill='#F19A34'
        fillRule='evenodd'
        d='M13.646 6.531l4.948.34c.095.147.191.293.291.437l-5.247-.36c0-.14.003-.278.008-.417z'
        clipRule='evenodd'></path>
      <path
        fill='#F19A34'
        fillRule='evenodd'
        d='M13.661 6.254l4.752.325c.089.147.181.293.276.437l-5.047-.346c.004-.14.01-.278.02-.416z'
        clipRule='evenodd'></path>
      <path
        fill='#F19A34'
        fillRule='evenodd'
        d='M13.683 5.977l4.56.312c.083.147.17.292.26.436l-4.85-.333c.008-.139.018-.277.03-.415z'
        clipRule='evenodd'></path>
      <path
        fill='#F19C34'
        fillRule='evenodd'
        d='M13.713 5.7l4.37.3c.078.146.16.29.244.434l-4.655-.319c.01-.139.024-.277.041-.415z'
        clipRule='evenodd'></path>
      <path
        fill='#F39C34'
        fillRule='evenodd'
        d='M13.75 5.424l4.183.287c.073.146.149.29.228.433l-4.464-.306c.015-.138.033-.276.054-.414z'
        clipRule='evenodd'></path>
      <path
        fill='#F39C34'
        fillRule='evenodd'
        d='M13.796 5.149l3.998.273c.067.146.138.29.212.433l-4.275-.293c.019-.138.04-.276.065-.413z'
        clipRule='evenodd'></path>
      <path
        fill='#F69F34'
        fillRule='evenodd'
        d='M13.849 4.874l3.816.261c.062.145.128.29.197.431l-4.09-.28c.023-.138.048-.275.077-.412z'
        clipRule='evenodd'></path>
      <path
        fill='#F69F34'
        fillRule='evenodd'
        d='M13.91 4.6l3.637.248c.057.145.117.289.18.43l-3.906-.267a9.49 9.49 0 01.09-.412z'
        clipRule='evenodd'></path>
      <path
        fill='#F69F34'
        fillRule='evenodd'
        d='M13.98 4.326l3.459.237c.052.144.106.287.165.429l-3.726-.256c.031-.137.065-.274.102-.41z'
        clipRule='evenodd'></path>
      <path
        fill='#F69F34'
        fillRule='evenodd'
        d='M14.058 4.052l3.284.225c.046.144.095.287.149.428l-3.547-.243a9.47 9.47 0 01.114-.41z'
        clipRule='evenodd'></path>
      <path
        fill='#F69F34'
        fillRule='evenodd'
        d='M14.146 3.78l3.107.213.028.094c.033.112.069.223.107.333l-3.37-.231c.04-.138.082-.274.128-.41z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A134'
        fillRule='evenodd'
        d='M14.243 3.508l2.937.201c.03.126.063.253.1.378l.016.048-3.195-.219c.044-.137.091-.273.142-.408z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A134'
        fillRule='evenodd'
        d='M14.348 3.237l2.773.19c.027.141.058.282.094.424l-3.022-.207c.049-.137.1-.273.155-.407z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A134'
        fillRule='evenodd'
        d='M14.465 2.966l2.607.178c.022.141.047.282.077.424l-2.855-.196c.054-.136.11-.271.17-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A134'
        fillRule='evenodd'
        d='M14.59 2.696l2.441.167c.019.14.04.281.064.422l-2.69-.184a9.27 9.27 0 01.186-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#F9A333'
        fillRule='evenodd'
        d='M14.727 2.427l2.27.155c.016.14.033.28.054.421l-2.525-.172c.064-.136.13-.27.201-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#F9A333'
        fillRule='evenodd'
        d='M14.874 2.158l2.093.144c.014.139.03.28.047.42l-2.357-.16c.069-.136.141-.27.217-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#F9A333'
        fillRule='evenodd'
        d='M15.033 1.89l1.906.13.043.422-2.183-.15a9.59 9.59 0 01.234-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA532'
        fillRule='evenodd'
        d='M15.203 1.623l1.708.117c.015.139.028.28.042.421l-2.001-.137c.08-.135.164-.268.251-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA532'
        fillRule='evenodd'
        d='M15.385 1.357l1.495.103c.017.138.032.278.046.42l-1.81-.123c.086-.135.176-.268.27-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA532'
        fillRule='evenodd'
        d='M15.58 1.092l1.263.087c.02.138.038.278.053.421l-1.603-.11c.091-.134.187-.266.287-.398z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA532'
        fillRule='evenodd'
        d='M15.788.828l1.01.069c.025.138.046.279.065.422l-1.382-.094c.098-.134.2-.266.307-.397z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA532'
        fillRule='evenodd'
        d='M16.01.565l.728.05c.033.137.06.278.084.423L15.682.96c.105-.133.214-.265.328-.395z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA632'
        fillRule='evenodd'
        d='M16.538 0c.103.236.177.49.232.756l-.873-.06c.199-.237.413-.469.64-.696z'
        clipRule='evenodd'></path>
      <path
        fill='#D63D3E'
        fillRule='evenodd'
        d='M13.978 69.79l3.59.255v.094c-1.154.04-2.37-.088-3.59-.35z'
        clipRule='evenodd'></path>
      <path
        fill='#D63D3E'
        fillRule='evenodd'
        d='M12.56 69.426l5.008.356v.357c-.14.005-.282.007-.424.007l-1.925-.137a17.925 17.925 0 01-2.66-.583z'
        clipRule='evenodd'></path>
      <path
        fill='#D63D3E'
        fillRule='evenodd'
        d='M11.534 69.09l6.034.43v.394l-4.379-.312a19.903 19.903 0 01-1.655-.512z'
        clipRule='evenodd'></path>
      <path
        fill='#D63D3E'
        fillRule='evenodd'
        d='M10.688 68.767l6.88.49v.394l-5.55-.395c-.448-.148-.893-.31-1.33-.489z'
        clipRule='evenodd'></path>
      <path
        fill='#D63F3F'
        fillRule='evenodd'
        d='M9.952 68.452l7.616.543v.394l-6.474-.462a20.966 20.966 0 01-1.142-.475z'
        clipRule='evenodd'></path>
      <path
        fill='#D63F3F'
        fillRule='evenodd'
        d='M9.298 68.143l8.27.59v.393l-7.26-.517c-.342-.147-.679-.302-1.01-.466z'
        clipRule='evenodd'></path>
      <path
        fill='#D63F3F'
        fillRule='evenodd'
        d='M8.704 67.838l8.864.632v.394l-7.951-.567c-.31-.146-.615-.3-.913-.459z'
        clipRule='evenodd'></path>
      <path
        fill='#D63F3F'
        fillRule='evenodd'
        d='M8.16 67.537l9.408.67v.394l-8.574-.61a20.306 20.306 0 01-.834-.454z'
        clipRule='evenodd'></path>
      <path
        fill='#D63F3F'
        fillRule='evenodd'
        d='M7.66 67.239l9.908.706v.394l-9.141-.652a19.824 19.824 0 01-.768-.448z'
        clipRule='evenodd'></path>
      <path
        fill='#D6413F'
        fillRule='evenodd'
        d='M7.194 66.943l10.374.74v.393l-9.663-.689a18.86 18.86 0 01-.711-.444z'
        clipRule='evenodd'></path>
      <path
        fill='#D6413F'
        fillRule='evenodd'
        d='M6.761 66.65l10.807.77v.393l-10.146-.722c-.226-.144-.446-.291-.66-.441z'
        clipRule='evenodd'></path>
      <path
        fill='#D6413F'
        fillRule='evenodd'
        d='M6.357 66.358l11.211.799v.394l-10.595-.755a17.43 17.43 0 01-.616-.438z'
        clipRule='evenodd'></path>
      <path
        fill='#D6413F'
        fillRule='evenodd'
        d='M5.98 66.069l11.588.825v.394l-11.013-.784a15.745 15.745 0 01-.575-.435z'
        clipRule='evenodd'></path>
      <path
        fill='#D6413F'
        fillRule='evenodd'
        d='M5.628 65.781l11.94.851v.394l-11.403-.812a15.204 15.204 0 01-.537-.433z'
        clipRule='evenodd'></path>
      <path
        fill='#D7413F'
        fillRule='evenodd'
        d='M5.299 65.495l12.27.874v.394L5.8 65.925a14.06 14.06 0 01-.502-.43z'
        clipRule='evenodd'></path>
      <path
        fill='#D7433F'
        fillRule='evenodd'
        d='M4.992 65.21l12.576.897v.394l-12.107-.863c-.162-.14-.318-.283-.469-.427z'
        clipRule='evenodd'></path>
      <path
        fill='#D7433F'
        fillRule='evenodd'
        d='M4.707 64.928l12.862.916v.394l-12.426-.885a12.266 12.266 0 01-.328-.315l-.108-.11z'
        clipRule='evenodd'></path>
      <path
        fill='#D7433F'
        fillRule='evenodd'
        d='M4.437 64.646l13.131.936v.394l-12.721-.907-.032-.03c-.13-.13-.256-.261-.378-.393z'
        clipRule='evenodd'></path>
      <path
        fill='#D8463F'
        fillRule='evenodd'
        d='M4.185 64.366l13.383.953v.394L4.57 64.787c-.132-.14-.261-.28-.385-.421z'
        clipRule='evenodd'></path>
      <path
        fill='#D8463F'
        fillRule='evenodd'
        d='M3.946 64.086l13.622.97v.394L4.31 64.506a13.153 13.153 0 01-.363-.42z'
        clipRule='evenodd'></path>
      <path
        fill='#D8463F'
        fillRule='evenodd'
        d='M3.722 63.808l13.846.986v.394l-13.504-.962a13.217 13.217 0 01-.342-.418z'
        clipRule='evenodd'></path>
      <path
        fill='#D8463F'
        fillRule='evenodd'
        d='M3.511 63.53l14.057 1.002v.394l-13.735-.98a12.746 12.746 0 01-.322-.416z'
        clipRule='evenodd'></path>
      <path
        fill='#D8463F'
        fillRule='evenodd'
        d='M3.312 63.254l14.256 1.015v.394l-13.953-.994a11.94 11.94 0 01-.303-.415z'
        clipRule='evenodd'></path>
      <path
        fill='#D8463F'
        fillRule='evenodd'
        d='M3.127 62.978l14.441 1.029v.393L3.411 63.392a12.164 12.164 0 01-.284-.414z'
        clipRule='evenodd'></path>
      <path
        fill='#D8473F'
        fillRule='evenodd'
        d='M2.952 62.703l14.616 1.04v.395l-14.35-1.023a12.038 12.038 0 01-.266-.413z'
        clipRule='evenodd'></path>
      <path
        fill='#D8473F'
        fillRule='evenodd'
        d='M2.787 62.428l14.782 1.054v.393L3.037 62.84c-.087-.136-.17-.274-.25-.412z'
        clipRule='evenodd'></path>
      <path
        fill='#D8473F'
        fillRule='evenodd'
        d='M2.634 62.155l14.934 1.064v.394l-14.7-1.048c-.081-.136-.16-.273-.234-.41z'
        clipRule='evenodd'></path>
      <path
        fill='#D84A3F'
        fillRule='evenodd'
        d='M2.49 61.882l15.078 1.074v.394L2.71 62.291c-.077-.135-.15-.272-.22-.409z'
        clipRule='evenodd'></path>
      <path
        fill='#D84A3F'
        fillRule='evenodd'
        d='M2.356 61.61l15.213 1.084v.394L2.56 62.018c-.072-.135-.14-.271-.205-.408z'
        clipRule='evenodd'></path>
      <path
        fill='#D84A3F'
        fillRule='evenodd'
        d='M2.231 61.338l15.337 1.093v.394l-15.146-1.08c-.067-.134-.13-.27-.191-.407z'
        clipRule='evenodd'></path>
      <path
        fill='#D84A3F'
        fillRule='evenodd'
        d='M2.115 61.068l15.454 1.1v.394L2.293 61.474a11.29 11.29 0 01-.178-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#D84A3F'
        fillRule='evenodd'
        d='M2.008 60.798l15.56 1.108v.394L2.172 61.203c-.058-.134-.112-.27-.164-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#D84C3F'
        fillRule='evenodd'
        d='M1.908 60.528l15.66 1.115v.394L2.06 60.933c-.054-.135-.104-.27-.152-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#DA4B3E'
        fillRule='evenodd'
        d='M1.816 60.259l15.752 1.122v.394L1.957 60.663c-.05-.134-.097-.27-.14-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#DA4B3E'
        fillRule='evenodd'
        d='M1.733 59.99l15.835 1.129v.393L1.861 60.393a11.026 11.026 0 01-.128-.403z'
        clipRule='evenodd'></path>
      <path
        fill='#DA4B3E'
        fillRule='evenodd'
        d='M1.656 59.722l15.912 1.134v.394L1.774 60.124c-.042-.133-.081-.267-.118-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#DA4E3E'
        fillRule='evenodd'
        d='M1.587 59.455l15.981 1.138v.394l-15.875-1.13a11.518 11.518 0 01-.106-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#DA4E3E'
        fillRule='evenodd'
        d='M1.524 59.188l16.044 1.143v.394L1.62 59.588a11.904 11.904 0 01-.096-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#DA4E3E'
        fillRule='evenodd'
        d='M1.468 58.921l16.1 1.147v.394l-16.014-1.14a11.55 11.55 0 01-.086-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#DA4E3E'
        fillRule='evenodd'
        d='M1.419 58.655l16.15 1.15v.395L1.494 59.054a12.056 12.056 0 01-.076-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#DA4E3E'
        fillRule='evenodd'
        d='M1.376 58.39l16.192 1.153v.394L1.443 58.788a11.866 11.866 0 01-.067-.398z'
        clipRule='evenodd'></path>
      <path
        fill='#DA503F'
        fillRule='evenodd'
        d='M1.339 58.125l16.23 1.156v.394L1.395 58.522c-.021-.132-.04-.264-.057-.397z'
        clipRule='evenodd'></path>
      <path
        fill='#DA503F'
        fillRule='evenodd'
        d='M1.307 57.86l16.261 1.158v.394L1.356 58.257a12.177 12.177 0 01-.049-.397z'
        clipRule='evenodd'></path>
      <path
        fill='#DA503F'
        fillRule='evenodd'
        d='M1.282 57.595l16.286 1.16v.395L1.322 57.992c-.015-.132-.029-.264-.04-.397z'
        clipRule='evenodd'></path>
      <path
        fill='#DA503F'
        fillRule='evenodd'
        d='M1.262 57.331l16.306 1.162v.394l-16.274-1.16a12.58 12.58 0 01-.032-.395z'
        clipRule='evenodd'></path>
      <path
        fill='#DA523F'
        fillRule='evenodd'
        d='M1.248 57.068l16.32 1.163v.393L1.272 57.463c-.01-.132-.018-.263-.024-.395z'
        clipRule='evenodd'></path>
      <path
        fill='#DA523F'
        fillRule='evenodd'
        d='M1.24 56.804l16.328 1.164v.394L1.254 57.2a13.159 13.159 0 01-.015-.396z'
        clipRule='evenodd'></path>
      <path
        fill='#DA523F'
        fillRule='evenodd'
        d='M1.235 56.542l16.333 1.163v.394L1.244 56.936a13.123 13.123 0 01-.008-.394z'
        clipRule='evenodd'></path>
      <path
        fill='#DA523F'
        fillRule='evenodd'
        d='M1.236 56.28l16.332 1.163v.394L1.236 56.673a14.474 14.474 0 010-.394z'
        clipRule='evenodd'></path>
      <path
        fill='#DA523F'
        fillRule='evenodd'
        d='M1.242 56.017l16.326 1.163v.394L1.235 56.41c0-.13.003-.261.007-.393z'
        clipRule='evenodd'></path>
      <path
        fill='#DA543F'
        fillRule='evenodd'
        d='M1.253 55.755l5.203.371c.274.048.557.069.847.06l10.265.732v.394L1.24 56.148c.003-.13.008-.262.014-.393z'
        clipRule='evenodd'></path>
      <path
        fill='#DA543F'
        fillRule='evenodd'
        d='M1.27 55.494l4.116.293c.901.421 1.939.539 3.044.217l9.138.651v.394l-16.32-1.163c.005-.13.012-.261.021-.392z'
        clipRule='evenodd'></path>
      <path
        fill='#DA543F'
        fillRule='evenodd'
        d='M1.29 55.233l3.552.253c.293.189.604.344.93.46l-4.511-.321c.008-.13.017-.261.028-.392zm7.749.552l8.53.608v.393l-9.554-.68a5.027 5.027 0 001.024-.32z'
        clipRule='evenodd'></path>
      <path
        fill='#DA543F'
        fillRule='evenodd'
        d='M1.314 54.972l3.122.223c.207.164.425.312.653.44l-3.81-.272c.01-.13.022-.26.035-.39zm8.194.584l8.06.574v.394l-8.81-.628a5.71 5.71 0 00.75-.34z'
        clipRule='evenodd'></path>
      <path
        fill='#DA563F'
        fillRule='evenodd'
        d='M1.343 54.712l2.764.197c.165.156.34.3.52.43l-3.326-.236c.012-.13.027-.261.042-.391zm8.565.61l7.66.546v.394l-8.284-.59a6.258 6.258 0 00.624-.35z'
        clipRule='evenodd'></path>
      <path
        fill='#DA563F'
        fillRule='evenodd'
        d='M1.377 54.452l2.452.174c.138.15.284.293.436.425l-2.937-.21c.015-.13.03-.26.049-.39zm8.877.632l7.314.52V56l-7.853-.56.03-.017c.177-.105.347-.218.509-.338z'
        clipRule='evenodd'></path>
      <path
        fill='#DA563F'
        fillRule='evenodd'
        d='M1.414 54.192l2.175.155c.119.147.243.287.374.42l-2.604-.185c.017-.13.035-.26.055-.39zm9.142.65l7.012.5v.394l-7.482-.533a5.75 5.75 0 00.47-.36z'
        clipRule='evenodd'></path>
      <path
        fill='#DA563F'
        fillRule='evenodd'
        d='M1.456 53.932l1.922.137c.104.145.213.284.327.417l-2.31-.164.06-.39zm9.366.667l6.746.481v.394l-7.159-.51c.145-.115.282-.237.413-.365z'
        clipRule='evenodd'></path>
      <path
        fill='#DA563F'
        fillRule='evenodd'
        d='M1.502 53.673l1.69.12c.091.143.187.28.288.414l-2.045-.145c.02-.13.043-.26.067-.39zm9.555.68l6.511.464v.394l-6.875-.49a5.2 5.2 0 00.364-.367z'
        clipRule='evenodd'></path>
      <path
        fill='#DB583F'
        fillRule='evenodd'
        d='M1.552 53.414l1.476.105c.08.141.165.279.255.412l-1.804-.129c.023-.13.047-.259.073-.388zm9.713.692l6.303.449v.394l-6.625-.472c.113-.119.22-.242.322-.371z'
        clipRule='evenodd'></path>
      <path
        fill='#DB583F'
        fillRule='evenodd'
        d='M1.606 53.155l1.277.091c.07.14.145.277.225.41l-1.582-.113c.025-.13.052-.258.08-.388zm9.843.701l6.12.436v.394l-6.405-.456c.1-.12.196-.244.285-.373z'
        clipRule='evenodd'></path>
      <path
        fill='#DB583F'
        fillRule='evenodd'
        d='M1.663 52.897l1.09.077c.063.139.13.275.2.409l-1.375-.099c.027-.129.055-.258.085-.387zm9.949.708l5.956.425v.393l-6.208-.442c.075-.1.145-.205.213-.312l.039-.064z'
        clipRule='evenodd'></path>
      <path
        fill='#DD583F'
        fillRule='evenodd'
        d='M1.724 52.638l.915.066c.055.137.114.273.177.406l-1.182-.084c.028-.13.059-.259.09-.388zm10.032.715l5.813.414v.394l-6.036-.43.04-.062c.065-.103.126-.209.183-.316z'
        clipRule='evenodd'></path>
      <path
        fill='#DD583F'
        fillRule='evenodd'
        d='M1.79 52.38l.75.054c.047.137.099.272.155.405l-1.002-.072c.03-.129.063-.258.096-.386zm10.091.72l5.687.405v.394l-5.882-.42c.07-.124.136-.25.195-.38z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5A3F'
        fillRule='evenodd'
        d='M1.858 52.123l.596.043c.04.136.085.27.134.403l-.832-.06c.032-.129.067-.257.102-.386zm10.133.722l5.577.397v.394l-5.747-.41c.062-.125.118-.252.17-.381z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5A3F'
        fillRule='evenodd'
        d='M1.93 51.865l.45.032c.034.136.072.27.115.403l-.672-.048c.034-.13.07-.258.107-.387zm10.156.724l5.482.39v.395l-5.63-.402c.054-.126.103-.254.148-.383z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5A3F'
        fillRule='evenodd'
        d='M2.006 51.608l.311.023c.029.134.062.268.098.4l-.521-.037c.036-.128.073-.257.112-.386zm10.161.724l5.401.385v.394l-5.528-.394c.047-.127.09-.255.127-.385z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5A3F'
        fillRule='evenodd'
        d='M2.085 51.352l.183.013c.022.133.048.267.079.399l-.38-.027c.038-.129.078-.257.118-.385zm10.151.723l5.332.38v.393l-5.44-.387a5.96 5.96 0 00.108-.386z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5C3F'
        fillRule='evenodd'
        d='M2.167 51.095l.062.004a6.4 6.4 0 00.062.398l-.246-.017c.04-.128.08-.257.122-.385zm10.127.721l5.274.376v.394l-5.365-.383c.034-.128.065-.256.09-.387z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5C3F'
        fillRule='evenodd'
        d='M12.34 51.557l5.229.372v.394l-5.303-.377c.029-.129.053-.258.074-.39zm-10.093-.325l-.121-.009.086-.264c.01.091.022.182.035.273z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5C3F'
        fillRule='evenodd'
        d='M12.377 51.297l5.191.37v.394l-5.25-.374c.023-.13.043-.26.059-.39zm-10.164-.33H2.21l.002-.008.001.008z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5C3F'
        fillRule='evenodd'
        d='M12.403 51.036l5.165.368v.394l-5.209-.37c.018-.13.033-.26.044-.392z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5C3F'
        fillRule='evenodd'
        d='M12.421 50.775l5.147.367v.394l-5.177-.37c.013-.13.024-.26.03-.391z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5E3F'
        fillRule='evenodd'
        d='M12.43 50.513l5.138.366v.394l-5.155-.367c.01-.13.015-.261.018-.393z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5E3F'
        fillRule='evenodd'
        d='M12.433 50.25l5.135.367v.394l-5.14-.367c.004-.13.006-.262.005-.393z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5E3F'
        fillRule='evenodd'
        d='M12.427 49.988l5.141.366v.394l-5.135-.366c0-.131-.001-.262-.006-.394z'
        clipRule='evenodd'></path>
      <path
        fill='#DD5E3F'
        fillRule='evenodd'
        d='M12.415 49.724l5.153.368v.394l-5.137-.366a9.853 9.853 0 00-.016-.395z'
        clipRule='evenodd'></path>
      <path
        fill='#DD603F'
        fillRule='evenodd'
        d='M12.396 49.46l5.172.369v.394l-5.146-.367a10.736 10.736 0 00-.026-.395z'
        clipRule='evenodd'></path>
      <path
        fill='#DD603F'
        fillRule='evenodd'
        d='M12.37 49.196l5.198.37v.394l-5.162-.368c-.01-.132-.022-.264-.036-.396z'
        clipRule='evenodd'></path>
      <path
        fill='#DD603F'
        fillRule='evenodd'
        d='M12.34 48.931l5.228.373v.394l-5.184-.37a12.394 12.394 0 00-.045-.397z'
        clipRule='evenodd'></path>
      <path
        fill='#DD603F'
        fillRule='evenodd'
        d='M12.302 48.666l5.266.375v.394l-5.213-.371a13.276 13.276 0 00-.053-.398z'
        clipRule='evenodd'></path>
      <path
        fill='#DF603F'
        fillRule='evenodd'
        d='M12.26 48.4l5.309.379v.394l-5.247-.374c-.019-.133-.04-.266-.062-.398z'
        clipRule='evenodd'></path>
      <path
        fill='#E0633F'
        fillRule='evenodd'
        d='M12.213 48.135l5.355.382v.393l-5.286-.377a14.738 14.738 0 00-.069-.398z'
        clipRule='evenodd'></path>
      <path
        fill='#E0633F'
        fillRule='evenodd'
        d='M12.161 47.869l5.407.385v.394l-5.331-.38a15.703 15.703 0 00-.076-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#E0633F'
        fillRule='evenodd'
        d='M12.105 47.602l5.463.39v.393l-5.38-.383a17.275 17.275 0 00-.083-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#E0633F'
        fillRule='evenodd'
        d='M12.044 47.335l5.524.394v.394l-5.435-.388a19.121 19.121 0 00-.089-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#E1643F'
        fillRule='evenodd'
        d='M11.98 47.068l5.588.398v.394l-5.493-.391c-.03-.135-.062-.269-.095-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#E1643F'
        fillRule='evenodd'
        d='M11.912 46.8l5.656.403v.394l-5.555-.395a20.804 20.804 0 00-.101-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#E1643F'
        fillRule='evenodd'
        d='M11.84 46.533l5.728.408v.394l-5.622-.4c-.034-.136-.07-.27-.106-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#E1643F'
        fillRule='evenodd'
        d='M11.765 46.265l5.803.414v.393l-5.692-.405a26.79 26.79 0 00-.11-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#E1643F'
        fillRule='evenodd'
        d='M11.687 45.997l5.881.419v.394l-5.765-.41c-.038-.137-.077-.27-.116-.403z'
        clipRule='evenodd'></path>
      <path
        fill='#E1663F'
        fillRule='evenodd'
        d='M11.607 45.729l5.961.424v.394l-5.842-.416a37.646 37.646 0 00-.106-.36l-.013-.042z'
        clipRule='evenodd'></path>
      <path
        fill='#E1663F'
        fillRule='evenodd'
        d='M11.524 45.46l6.045.43v.395l-5.922-.422-.027-.093-.096-.31z'
        clipRule='evenodd'></path>
      <path
        fill='#E1663F'
        fillRule='evenodd'
        d='M11.44 45.192l6.128.436v.394l-6.002-.428a42.582 42.582 0 00-.127-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#E1663F'
        fillRule='evenodd'
        d='M11.352 44.923l6.216.443v.394l-6.086-.434a37.716 37.716 0 00-.13-.403z'
        clipRule='evenodd'></path>
      <path
        fill='#E1683F'
        fillRule='evenodd'
        d='M11.263 44.654l6.305.45v.393l-6.172-.44a46.311 46.311 0 00-.133-.403z'
        clipRule='evenodd'></path>
      <path
        fill='#E1683F'
        fillRule='evenodd'
        d='M11.172 44.385l6.396.456v.394l-6.26-.446-.136-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E1683F'
        fillRule='evenodd'
        d='M11.08 44.116l6.489.462v.394l-6.351-.452a50.56 50.56 0 00-.138-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E1683F'
        fillRule='evenodd'
        d='M10.985 43.846l6.584.47v.393l-6.443-.458-.141-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E1683F'
        fillRule='evenodd'
        d='M10.889 43.577l6.68.476v.394l-6.537-.466-.143-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E16A3F'
        fillRule='evenodd'
        d='M10.79 43.308l6.778.483v.393l-6.631-.472-.146-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E16A3F'
        fillRule='evenodd'
        d='M10.691 43.038l6.877.49v.394l-6.728-.48-.149-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E16A3F'
        fillRule='evenodd'
        d='M10.59 42.768l6.979.497v.394l-6.827-.486-.151-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E16A3F'
        fillRule='evenodd'
        d='M10.489 42.498l7.08.505v.394l-6.928-.494-.152-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E16A3F'
        fillRule='evenodd'
        d='M10.386 42.229l7.182.511v.394l-7.028-.5-.154-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E16B3F'
        fillRule='evenodd'
        d='M10.281 41.959l7.287.519v.394l-7.13-.508-.157-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E16B3F'
        fillRule='evenodd'
        d='M10.176 41.688l7.392.527v.394l-7.235-.515-.157-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#E16B3F'
        fillRule='evenodd'
        d='M10.07 41.419l7.498.534v.393l-7.34-.522-.159-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E16B3F'
        fillRule='evenodd'
        d='M9.962 41.148l7.607.542v.394l-7.446-.53-.16-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#E16D3F'
        fillRule='evenodd'
        d='M9.854 40.878l7.714.55v.394l-7.552-.539-.162-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E16D3F'
        fillRule='evenodd'
        d='M9.746 40.608l7.822.557v.394l-7.66-.546-.162-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E46D3F'
        fillRule='evenodd'
        d='M9.637 40.338l7.931.565v.393L9.8 40.743l-.163-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E46D3F'
        fillRule='evenodd'
        d='M9.527 40.067l8.041.573v.394l-7.877-.561-.164-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#E46D3F'
        fillRule='evenodd'
        d='M9.417 39.797l8.151.58v.394l-7.986-.569-.165-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E46F3F'
        fillRule='evenodd'
        d='M9.308 39.526l8.26.589v.394l-8.096-.577-.164-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#E46F3F'
        fillRule='evenodd'
        d='M9.197 39.256l8.371.596v.394l-8.205-.584-.166-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#E46F3F'
        fillRule='evenodd'
        d='M9.087 38.986l8.481.604v.394l-8.315-.593-.166-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E46F3F'
        fillRule='evenodd'
        d='M8.977 38.715l8.591.612v.394l-8.426-.6-.165-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#E4713F'
        fillRule='evenodd'
        d='M8.867 38.445l8.701.62v.394l-8.536-.609-.165-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E4713F'
        fillRule='evenodd'
        d='M8.758 38.175l8.81.627v.394l-8.646-.616-.164-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E4713F'
        fillRule='evenodd'
        d='M8.648 37.904l8.92.635v.395l-8.756-.624-.164-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#E4713F'
        fillRule='evenodd'
        d='M8.54 37.634l9.028.643v.394l-8.865-.632-.164-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E4713F'
        fillRule='evenodd'
        d='M8.431 37.364l9.137.65v.394l-8.974-.64-.163-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E4723F'
        fillRule='evenodd'
        d='M8.324 37.093l9.244.659v.394l-9.083-.647-.161-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#E4723F'
        fillRule='evenodd'
        d='M8.217 36.823l9.351.666v.395l-9.19-.655-.161-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#E4723F'
        fillRule='evenodd'
        d='M8.111 36.553l9.457.674v.394l-9.298-.663-.159-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E4723F'
        fillRule='evenodd'
        d='M8.006 36.283l9.562.682v.393l-9.404-.67-.158-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E4743F'
        fillRule='evenodd'
        d='M7.902 36.013l9.666.689v.394l-9.51-.678-.058-.15-.098-.255z'
        clipRule='evenodd'></path>
      <path
        fill='#E4743F'
        fillRule='evenodd'
        d='M7.799 35.743l9.77.696v.394l-9.615-.685-.155-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E4743F'
        fillRule='evenodd'
        d='M7.696 35.473l9.872.704v.394l-9.718-.693-.154-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E6753F'
        fillRule='evenodd'
        d='M7.595 35.203l9.973.711v.394l-9.82-.7-.153-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E6753F'
        fillRule='evenodd'
        d='M7.495 34.934l10.073.718v.393l-9.922-.707-.151-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E6773F'
        fillRule='evenodd'
        d='M7.396 34.664l10.172.725v.394l-10.023-.714-.15-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E6773F'
        fillRule='evenodd'
        d='M7.298 34.395l10.27.732v.393L7.446 34.8l-.147-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E6773F'
        fillRule='evenodd'
        d='M7.201 34.125l10.367.74v.393L7.346 34.53a57.675 57.675 0 01-.145-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#E6783F'
        fillRule='evenodd'
        d='M7.107 33.856l10.461.745v.394L7.25 34.26a55.697 55.697 0 01-.142-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E6783F'
        fillRule='evenodd'
        d='M7.014 33.587l10.554.752v.394L7.154 33.99a43.684 43.684 0 01-.14-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E6783F'
        fillRule='evenodd'
        d='M6.922 33.318l10.646.759v.393L7.06 33.722a52.693 52.693 0 01-.138-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E6783F'
        fillRule='evenodd'
        d='M6.833 33.049l10.736.765v.394l-10.601-.755a48.04 48.04 0 01-.135-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E6783F'
        fillRule='evenodd'
        d='M6.745 32.78l10.823.771v.394l-10.69-.761a48.103 48.103 0 01-.133-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#E67A3F'
        fillRule='evenodd'
        d='M6.66 32.512l10.909.777v.393l-10.78-.768a43.529 43.529 0 01-.13-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#E67A3F'
        fillRule='evenodd'
        d='M6.576 32.243l10.995.783c-.002.121-.003.243-.003.364v.03l-10.866-.774a38.253 38.253 0 01-.126-.403z'
        clipRule='evenodd'></path>
      <path
        fill='#E67A3F'
        fillRule='evenodd'
        d='M6.495 31.975l11.081.79c-.003.13-.005.261-.006.393l-10.952-.78a40.758 40.758 0 01-.123-.403z'
        clipRule='evenodd'></path>
      <path
        fill='#E77B3F'
        fillRule='evenodd'
        d='M6.416 31.706l11.168.796a22.42 22.42 0 00-.01.393L6.534 32.11l-.119-.403z'
        clipRule='evenodd'></path>
      <path
        fill='#E77B3F'
        fillRule='evenodd'
        d='M6.34 31.439l11.254.802c-.006.13-.01.261-.014.392L6.456 31.84c-.04-.133-.078-.267-.116-.401z'
        clipRule='evenodd'></path>
      <path
        fill='#E77B3F'
        fillRule='evenodd'
        d='M6.266 31.17l11.341.809c-.007.13-.013.261-.018.392l-11.211-.798a29.665 29.665 0 01-.112-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#E77B3F'
        fillRule='evenodd'
        d='M6.194 30.903l11.43.814c-.01.13-.016.262-.023.392l-11.299-.804a33.292 33.292 0 01-.108-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#E77B3F'
        fillRule='evenodd'
        d='M6.125 30.636l11.517.82c-.01.13-.019.262-.027.392L6.23 31.037a29.77 29.77 0 01-.104-.401z'
        clipRule='evenodd'></path>
      <path
        fill='#E77D3F'
        fillRule='evenodd'
        d='M6.059 30.368l11.605.827c-.012.13-.022.261-.031.392l-11.474-.818a30.423 30.423 0 01-.1-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#E77D3F'
        fillRule='evenodd'
        d='M5.996 30.101l11.692.834c-.013.13-.024.26-.035.39l-11.561-.823a27.284 27.284 0 01-.096-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#E77D3F'
        fillRule='evenodd'
        d='M5.936 29.834l11.78.84c-.015.13-.028.26-.04.39l-11.649-.83a27.829 27.829 0 01-.091-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#E77D3F'
        fillRule='evenodd'
        d='M5.878 29.568l11.868.845c-.016.13-.03.26-.044.39l-11.737-.835a25.43 25.43 0 01-.087-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#E77D3F'
        fillRule='evenodd'
        d='M5.824 29.302l11.955.851-.049.39-11.823-.842a23.385 23.385 0 01-.083-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#E77E3F'
        fillRule='evenodd'
        d='M5.773 29.035l12.043.858c-.02.13-.037.26-.054.39l-11.911-.848a21.643 21.643 0 01-.078-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#E77E3F'
        fillRule='evenodd'
        d='M5.726 28.77l12.129.864c-.02.13-.04.26-.058.39l-11.999-.856a21.75 21.75 0 01-.072-.399z'
        clipRule='evenodd'></path>
      <path
        fill='#E77E3F'
        fillRule='evenodd'
        d='M5.682 28.504l12.215.87c-.022.13-.043.26-.062.39l-12.086-.862a21.613 21.613 0 01-.067-.398z'
        clipRule='evenodd'></path>
      <path
        fill='#EA813F'
        fillRule='evenodd'
        d='M5.642 28.238l12.3.877-.067.389-12.171-.867a19.932 19.932 0 01-.062-.399z'
        clipRule='evenodd'></path>
      <path
        fill='#EA813F'
        fillRule='evenodd'
        d='M5.606 27.973l4.435.316c.848.393 1.74.4 2.598.185l5.352.382c-.025.129-.049.258-.072.388l-12.257-.873a18.66 18.66 0 01-.056-.398z'
        clipRule='evenodd'></path>
      <path
        fill='#EA813F'
        fillRule='evenodd'
        d='M5.574 27.708l3.938.28a3.539 3.539 0 00.943.461l-4.832-.343a17.263 17.263 0 01-.05-.398zm7.736.551l4.733.338-.077.388-5.814-.414c.393-.057.78-.166 1.158-.312z'
        clipRule='evenodd'></path>
      <path
        fill='#EA813F'
        fillRule='evenodd'
        d='M5.545 27.444l3.594.256c.184.163.387.309.61.437l-4.16-.296c-.016-.133-.03-.265-.044-.397zm8.283.59l4.27.304c-.028.13-.055.258-.081.388l-5.014-.357c.28-.092.556-.205.825-.335z'
        clipRule='evenodd'></path>
      <path
        fill='#EA813F'
        fillRule='evenodd'
        d='M5.52 27.18l3.331.237c.14.153.295.296.462.427l-3.754-.268a16.006 16.006 0 01-.038-.397zm8.748.623l3.888.277c-.03.129-.058.258-.086.388l-4.489-.32c.235-.103.465-.22.687-.345z'
        clipRule='evenodd'></path>
      <path
        fill='#EA823F'
        fillRule='evenodd'
        d='M5.502 26.916l3.118.222a3.9 3.9 0 00.367.42l-3.454-.246a16.98 16.98 0 01-.031-.396zm9.157.652l3.559.253c-.032.13-.062.258-.092.388l-4.07-.29c.207-.11.408-.227.603-.351z'
        clipRule='evenodd'></path>
      <path
        fill='#EA823F'
        fillRule='evenodd'
        d='M5.487 26.652l2.94.21c.093.144.193.283.303.415l-3.219-.23c-.01-.132-.018-.264-.024-.395zm9.526.679l3.27.233c-.033.128-.066.257-.097.386l-3.717-.264c.148-.09.293-.183.434-.279l.11-.076z'
        clipRule='evenodd'></path>
      <path
        fill='#EA823F'
        fillRule='evenodd'
        d='M5.477 26.389l2.79.198c.076.143.16.28.252.412l-3.025-.215a14.023 14.023 0 01-.017-.395zm9.868.703l3.007.214c-.035.128-.07.257-.102.386l-3.41-.242.063-.043c.152-.104.3-.209.442-.315z'
        clipRule='evenodd'></path>
      <path
        fill='#EA843F'
        fillRule='evenodd'
        d='M5.472 26.126l2.659.19c.064.14.135.276.212.408l-2.862-.204a13.872 13.872 0 01-.01-.394zm10.183.725l2.769.198c-.037.128-.073.257-.107.386l-3.135-.223c.163-.119.321-.239.473-.36z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8440'
        fillRule='evenodd'
        d='M5.471 25.863l2.545.182c.054.138.114.274.18.406l-2.723-.194a13.058 13.058 0 01-.002-.394zm10.476.747l2.552.181c-.038.129-.076.257-.112.386l-2.885-.205c.154-.12.303-.24.445-.362z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8440'
        fillRule='evenodd'
        d='M5.477 25.601l2.441.174c.046.138.096.273.152.405l-2.6-.186c0-.131.003-.262.007-.393zm10.743.766l2.359.168c-.04.128-.08.256-.118.385l-2.657-.19c.144-.12.283-.24.416-.363z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8440'
        fillRule='evenodd'
        d='M5.488 25.34l2.348.167c.038.136.081.27.129.403l-2.491-.177c.003-.132.007-.263.014-.393zm10.987.782l2.187.156c-.043.128-.084.256-.124.385l-2.452-.175c.135-.12.264-.242.389-.366z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8440'
        fillRule='evenodd'
        d='M5.506 25.078l2.261.161c.032.136.068.27.108.402l-2.393-.17c.006-.132.014-.263.024-.393zm11.207.798l2.036.145c-.045.128-.088.256-.13.385l-2.27-.162c.127-.12.248-.243.364-.368z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8640'
        fillRule='evenodd'
        d='M5.529 24.817l2.182.156c.026.135.056.268.09.4l-2.305-.165c.009-.13.02-.261.033-.39zm11.407.813l1.904.136c-.047.127-.092.255-.136.384L16.596 26c.119-.122.232-.245.34-.37z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8640'
        fillRule='evenodd'
        d='M5.559 24.557l2.107.15c.02.134.044.267.072.399l-2.222-.159c.012-.13.026-.26.043-.39zm11.584.825l1.791.128c-.048.127-.095.255-.14.383l-1.967-.14c.11-.122.215-.246.316-.37z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8640'
        fillRule='evenodd'
        d='M5.596 24.297l2.035.145c.015.133.034.266.056.398l-2.144-.153c.015-.131.032-.261.053-.39zm11.739.836l1.698.121c-.05.127-.1.255-.147.384l-1.845-.132c.103-.123.2-.247.294-.373z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8740'
        fillRule='evenodd'
        d='M5.64 24.038l1.965.14c.011.132.025.265.042.396l-2.07-.147c.018-.131.04-.26.063-.39zm11.873.845l1.623.116c-.052.127-.104.255-.153.383l-1.742-.124a7.9 7.9 0 00.272-.375z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8740'
        fillRule='evenodd'
        d='M5.692 23.779l1.896.135c.007.132.016.264.029.395l-2-.142c.022-.13.047-.26.075-.388zm11.986.854l1.565.111c-.054.127-.108.254-.16.382l-1.657-.118c.088-.124.172-.249.252-.375z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8740'
        fillRule='evenodd'
        d='M5.752 23.52l1.827.13c.003.132.008.264.017.396l-1.931-.138c.026-.13.055-.26.087-.388zm12.077.86l1.526.11c-.057.126-.113.253-.166.381l-1.592-.113c.082-.124.158-.25.232-.377z'
        clipRule='evenodd'></path>
      <path
        fill='#EA8740'
        fillRule='evenodd'
        d='M5.82 23.262l1.759.126c-.002.131 0 .263.004.394L5.72 23.65c.03-.13.063-.259.1-.387zm12.148.866l1.503.107c-.06.127-.117.254-.173.382l-1.543-.11c.075-.125.146-.252.213-.379z'
        clipRule='evenodd'></path>
      <path
        fill='#EB8940'
        fillRule='evenodd'
        d='M5.898 23.006l1.687.12a9.27 9.27 0 00-.007.393l-1.793-.128a7.95 7.95 0 01.113-.385zm12.197.868l1.496.107c-.061.126-.12.253-.18.381l-1.511-.108c.069-.125.134-.252.195-.38z'
        clipRule='evenodd'></path>
      <path
        fill='#EB8940'
        fillRule='evenodd'
        d='M5.985 22.75l1.614.114c-.009.13-.015.262-.018.393l-1.723-.123c.039-.13.081-.258.127-.384zm12.225.87l1.506.108a18.83 18.83 0 00-.186.38l-1.497-.107c.063-.125.122-.253.177-.38z'
        clipRule='evenodd'></path>
      <path
        fill='#EB8940'
        fillRule='evenodd'
        d='M6.082 22.494l1.538.11c-.012.13-.022.26-.029.391l-1.651-.117c.043-.128.09-.255.14-.38l.002-.004zm12.233.871l1.531.11c-.066.125-.13.252-.193.38l-1.499-.108c.058-.126.111-.253.16-.382z'
        clipRule='evenodd'></path>
      <path
        fill='#EB8940'
        fillRule='evenodd'
        d='M6.19 22.239l1.458.104c-.016.129-.029.26-.04.39l-1.576-.112.048-.123a7.53 7.53 0 01.11-.26zm12.218.87l1.573.112c-.068.126-.135.253-.2.38l-1.517-.108c.052-.127.1-.255.144-.384z'
        clipRule='evenodd'></path>
      <path
        fill='#EB8A40'
        fillRule='evenodd'
        d='M6.309 21.985l1.374.098c-.019.129-.036.259-.05.39l-1.499-.107a7.38 7.38 0 01.175-.381zm12.182.867l1.63.117c-.07.125-.14.252-.208.379l-1.55-.11c.046-.128.09-.256.128-.386z'
        clipRule='evenodd'></path>
      <path
        fill='#EB8A40'
        fillRule='evenodd'
        d='M6.44 21.732l1.284.091c-.022.129-.042.258-.06.39l-1.416-.101c.06-.13.125-.256.192-.38zm12.124.863l1.702.122c-.074.125-.145.251-.215.378l-1.6-.114a7.33 7.33 0 00.113-.386z'
        clipRule='evenodd'></path>
      <path
        fill='#ED8B40'
        fillRule='evenodd'
        d='M6.584 21.48l1.188.084c-.025.128-.048.258-.07.389l-1.33-.095c.068-.129.138-.255.212-.379zm12.044.857l1.789.128c-.077.125-.15.25-.224.378l-1.664-.119c.036-.128.07-.257.099-.387z'
        clipRule='evenodd'></path>
      <path
        fill='#EF8C40'
        fillRule='evenodd'
        d='M6.74 21.228l1.088.077c-.03.128-.056.257-.08.388l-1.238-.088c.074-.128.15-.254.23-.377zm11.941.85l1.892.135c-.08.125-.156.251-.232.378l-1.744-.125c.031-.128.06-.257.084-.388z'
        clipRule='evenodd'></path>
      <path
        fill='#F08E40'
        fillRule='evenodd'
        d='M6.912 20.978l.979.07a9.766 9.766 0 00-.092.387l-1.138-.082a7.19 7.19 0 01.25-.375zm11.815.841l2.008.143c-.082.125-.162.25-.24.377l-1.839-.131a7.57 7.57 0 00.07-.389z'
        clipRule='evenodd'></path>
      <path
        fill='#F08E40'
        fillRule='evenodd'
        d='M7.098 20.728l.863.062c-.037.126-.071.255-.103.386l-1.033-.073c.087-.128.178-.253.273-.375zm11.665.831l2.14.153c-.085.124-.168.25-.25.376l-1.948-.139c.022-.129.042-.259.058-.39z'
        clipRule='evenodd'></path>
      <path
        fill='#F08E40'
        fillRule='evenodd'
        d='M7.3 20.48l.739.052c-.04.126-.079.255-.114.387l-.922-.066a7.4 7.4 0 01.297-.373zm11.49.819l2.287.162c-.088.125-.174.25-.259.376l-2.072-.148c.018-.129.033-.26.044-.39z'
        clipRule='evenodd'></path>
      <path
        fill='#F08E40'
        fillRule='evenodd'
        d='M7.52 20.233l.605.043a8.394 8.394 0 00-.127.385l-.8-.057c.102-.127.21-.25.321-.37zm11.29.805l2.447.174c-.091.124-.18.249-.268.375l-2.212-.158c.014-.13.025-.26.032-.391z'
        clipRule='evenodd'></path>
      <path
        fill='#F08E40'
        fillRule='evenodd'
        d='M7.757 19.988l.464.033a8.091 8.091 0 00-.14.383l-.673-.047c.112-.126.228-.25.349-.37zm11.064.788l2.623.187c-.095.123-.188.248-.278.374l-2.365-.169c.01-.13.016-.26.02-.392z'
        clipRule='evenodd'></path>
      <path
        fill='#F08F40'
        fillRule='evenodd'
        d='M8.014 19.743l.313.023-.042.098a7.572 7.572 0 00-.113.284l-.536-.038c.121-.125.247-.248.378-.367zm10.81.77l2.813.2c-.098.124-.194.249-.288.374l-2.533-.18c.005-.13.008-.262.008-.394z'
        clipRule='evenodd'></path>
      <path
        fill='#F08F40'
        fillRule='evenodd'
        d='M8.292 19.5l.153.011c-.056.115-.11.233-.16.353l-.012.03-.39-.029c.131-.125.268-.246.409-.364zm10.528.75l3.017.216c-.101.123-.2.247-.298.372l-2.715-.193c.001-.13 0-.262-.004-.395z'
        clipRule='evenodd'></path>
      <path
        fill='#F08F40'
        fillRule='evenodd'
        d='M18.809 19.987l3.237.23a17.38 17.38 0 00-.31.373l-2.913-.208a9.934 9.934 0 00-.014-.395zm-10.424-.349l-.234-.016a9.05 9.05 0 01.41-.339 7.207 7.207 0 00-.176.355z'
        clipRule='evenodd'></path>
      <path
        fill='#F09140'
        fillRule='evenodd'
        d='M18.79 19.724l3.471.247c-.108.122-.215.246-.32.37l-3.125-.222a9.88 9.88 0 00-.026-.395zm-10.281-.34l-.07-.004.123-.097-.053.102z'
        clipRule='evenodd'></path>
      <path
        fill='#F09140'
        fillRule='evenodd'
        d='M18.765 19.459l3.72.265c-.113.122-.223.246-.332.37l-3.353-.239c-.009-.13-.02-.263-.035-.396z'
        clipRule='evenodd'></path>
      <path
        fill='#F09140'
        fillRule='evenodd'
        d='M18.733 19.194l3.984.284c-.117.122-.232.245-.345.37l-3.594-.257a10.613 10.613 0 00-.045-.397z'
        clipRule='evenodd'></path>
      <path
        fill='#F09140'
        fillRule='evenodd'
        d='M18.694 18.929l4.263.304a17.7 17.7 0 00-.357.368l-3.85-.274a11.55 11.55 0 00-.056-.398z'
        clipRule='evenodd'></path>
      <path
        fill='#F09140'
        fillRule='evenodd'
        d='M18.648 18.663l4.56.325c-.127.12-.25.244-.371.367l-4.123-.294c-.02-.131-.041-.264-.066-.398z'
        clipRule='evenodd'></path>
      <path
        fill='#F09240'
        fillRule='evenodd'
        d='M18.597 18.397l4.87.347c-.131.12-.26.243-.386.366l-4.409-.314a12.06 12.06 0 00-.075-.399z'
        clipRule='evenodd'></path>
      <path
        fill='#F09240'
        fillRule='evenodd'
        d='M18.54 18.13l5.197.37c-.136.12-.27.243-.401.366l-4.713-.336a12.443 12.443 0 00-.083-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#F39340'
        fillRule='evenodd'
        d='M18.477 17.863l5.54.395c-.142.12-.28.24-.417.364l-5.03-.358c-.03-.133-.06-.267-.093-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#F39540'
        fillRule='evenodd'
        d='M18.407 17.596l5.9.42c-.146.12-.29.24-.432.363l-5.366-.382a13.937 13.937 0 00-.102-.401z'
        clipRule='evenodd'></path>
      <path
        fill='#F39540'
        fillRule='evenodd'
        d='M18.333 17.328l6.238.444a3.064 3.064 0 01-.099.112c-.105.083-.209.168-.311.253l-5.719-.407a15.199 15.199 0 00-.11-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#F39540'
        fillRule='evenodd'
        d='M18.253 17.06l6.502.463a2.597 2.597 0 01-.283.36l-.014.012-6.087-.433a15.56 15.56 0 00-.118-.402z'
        clipRule='evenodd'></path>
      <path
        fill='#F39540'
        fillRule='evenodd'
        d='M18.167 16.791l6.722.479a1.83 1.83 0 01-.22.378l-6.376-.454a15.932 15.932 0 00-.1-.326l-.026-.077z'
        clipRule='evenodd'></path>
      <path
        fill='#F39540'
        fillRule='evenodd'
        d='M18.076 16.522l6.892.49a1.39 1.39 0 01-.14.385l-6.618-.472-.018-.057a17.098 17.098 0 00-.116-.346z'
        clipRule='evenodd'></path>
      <path
        fill='#F39640'
        fillRule='evenodd'
        d='M17.982 16.253l7.007.499v.07a1.206 1.206 0 01-.054.32l-6.813-.485c-.045-.136-.092-.27-.14-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#F39640'
        fillRule='evenodd'
        d='M17.882 15.983l7.074.504a1.402 1.402 0 01.03.396l-6.956-.496c-.048-.135-.097-.27-.148-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#F39640'
        fillRule='evenodd'
        d='M17.778 15.713l7.101.506c.05.138.084.272.1.4l-7.047-.501c-.05-.135-.1-.27-.154-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#F39840'
        fillRule='evenodd'
        d='M17.67 15.443l7.096.505c.065.138.118.274.157.406l-7.092-.506c-.052-.135-.106-.27-.16-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#F39840'
        fillRule='evenodd'
        d='M17.56 15.172l7.064.504c.078.137.147.274.203.408l-7.102-.506c-.054-.136-.11-.27-.166-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#F39840'
        fillRule='evenodd'
        d='M17.444 14.902l7.013.5c.089.137.17.274.242.41l-7.084-.504-.17-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#F39840'
        fillRule='evenodd'
        d='M17.326 14.63l6.941.495c.099.137.192.276.276.414l-7.041-.502a30.947 30.947 0 00-.176-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#F39840'
        fillRule='evenodd'
        d='M17.205 14.36l6.854.488c.106.136.21.275.305.415l-6.979-.497c-.059-.136-.119-.271-.18-.407z'
        clipRule='evenodd'></path>
      <path
        fill='#F49A40'
        fillRule='evenodd'
        d='M17.081 14.088l6.753.481c.113.136.224.276.331.418l-6.9-.492c-.06-.136-.121-.271-.184-.407z'
        clipRule='evenodd'></path>
      <path
        fill='#F49A40'
        fillRule='evenodd'
        d='M16.956 13.817l6.638.473c.118.134.238.274.354.418l-6.804-.484a53.62 53.62 0 00-.188-.407z'
        clipRule='evenodd'></path>
      <path
        fill='#F49A40'
        fillRule='evenodd'
        d='M16.828 13.545l6.514.464c.122.133.248.274.374.42l-6.697-.477a55.57 55.57 0 00-.19-.407z'
        clipRule='evenodd'></path>
      <path
        fill='#F49C40'
        fillRule='evenodd'
        d='M16.699 13.273l6.38.455c.122.129.255.27.39.421l-6.577-.468-.193-.408z'
        clipRule='evenodd'></path>
      <path
        fill='#F49C40'
        fillRule='evenodd'
        d='M16.568 13.002l6.241.444c.118.123.255.265.402.422l-6.448-.459-.195-.408z'
        clipRule='evenodd'></path>
      <path
        fill='#F49C40'
        fillRule='evenodd'
        d='M16.437 12.73l6.1.434.246.255.162.168-6.311-.45-.129-.266-.068-.141z'
        clipRule='evenodd'></path>
      <path
        fill='#F49C40'
        fillRule='evenodd'
        d='M16.303 12.457l5.957.425c.138.14.276.281.413.423l-6.17-.44a64.15 64.15 0 00-.2-.408z'
        clipRule='evenodd'></path>
      <path
        fill='#F49C40'
        fillRule='evenodd'
        d='M16.17 12.185l5.813.415.416.423-6.029-.43-.2-.408z'
        clipRule='evenodd'></path>
      <path
        fill='#F49E40'
        fillRule='evenodd'
        d='M16.037 11.914l5.667.403.418.424-5.886-.42a56.53 56.53 0 01-.2-.407z'
        clipRule='evenodd'></path>
      <path
        fill='#F49E40'
        fillRule='evenodd'
        d='M15.908 11.642l5.517.393.418.423-5.74-.409c-.066-.134-.131-.27-.196-.407z'
        clipRule='evenodd'></path>
      <path
        fill='#F49E40'
        fillRule='evenodd'
        d='M15.782 11.37l5.365.382.418.424-5.593-.398a23.183 23.183 0 01-.19-.408z'
        clipRule='evenodd'></path>
      <path
        fill='#F49F40'
        fillRule='evenodd'
        d='M15.663 11.1l5.208.37.415.423-5.442-.387a16.267 16.267 0 01-.181-.407z'
        clipRule='evenodd'></path>
      <path
        fill='#F69F3F'
        fillRule='evenodd'
        d='M15.551 10.829l5.047.36.41.422-5.286-.376c-.06-.136-.117-.272-.171-.406z'
        clipRule='evenodd'></path>
      <path
        fill='#F69F3F'
        fillRule='evenodd'
        d='M15.448 10.559l4.88.348c.134.141.27.282.406.422l-5.128-.365a9.701 9.701 0 01-.158-.405z'
        clipRule='evenodd'></path>
      <path
        fill='#F69F3F'
        fillRule='evenodd'
        d='M15.357 10.29l4.706.335c.132.141.265.282.399.422l-4.964-.353a7.465 7.465 0 01-.141-.404z'
        clipRule='evenodd'></path>
      <path
        fill='#F6A13F'
        fillRule='evenodd'
        d='M15.28 10.022l4.523.322c.13.142.26.282.392.422l-4.794-.342a5.822 5.822 0 01-.115-.376l-.006-.026z'
        clipRule='evenodd'></path>
      <path
        fill='#F6A13F'
        fillRule='evenodd'
        d='M15.212 9.754l4.337.31.383.42-4.616-.328-.03-.108c-.026-.098-.05-.196-.074-.294z'
        clipRule='evenodd'></path>
      <path
        fill='#F6A13F'
        fillRule='evenodd'
        d='M15.15 9.487l4.153.296c.123.142.247.282.373.42l-4.431-.315a14.148 14.148 0 01-.095-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#F6A13F'
        fillRule='evenodd'
        d='M15.093 9.22l3.97.284c.12.14.24.28.362.42L15.18 9.62a13.55 13.55 0 01-.087-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#F6A13F'
        fillRule='evenodd'
        d='M15.043 8.955l3.787.27c.116.14.233.28.352.418l-4.062-.289a12.995 12.995 0 01-.077-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A33F'
        fillRule='evenodd'
        d='M14.998 8.689l3.608.257c.112.141.225.28.34.418l-3.88-.276a12.501 12.501 0 01-.068-.4z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A33F'
        fillRule='evenodd'
        d='M14.959 8.423l3.43.245c.108.14.217.28.328.417l-3.698-.263a12.597 12.597 0 01-.06-.399z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A33F'
        fillRule='evenodd'
        d='M14.927 8.159l3.254.232c.104.14.21.279.316.416l-3.52-.25a11.4 11.4 0 01-.05-.398z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A53F'
        fillRule='evenodd'
        d='M14.9 7.894l3.081.22.03.04c.09.127.18.252.273.375l-3.342-.238c-.017-.133-.03-.265-.042-.397z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A53F'
        fillRule='evenodd'
        d='M14.88 7.63l2.91.207c.072.107.146.213.22.318l.07.097-3.168-.225a11.65 11.65 0 01-.032-.397z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A53F'
        fillRule='evenodd'
        d='M14.867 7.367l2.74.195c.09.14.183.277.278.414l-2.996-.214c-.01-.132-.017-.264-.022-.395z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A53F'
        fillRule='evenodd'
        d='M14.86 7.104l2.573.183c.086.139.174.276.264.413l-2.824-.202a10.46 10.46 0 01-.013-.394z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A53F'
        fillRule='evenodd'
        d='M14.86 6.841l2.407.172c.082.138.166.275.252.412l-2.656-.19a9.958 9.958 0 01-.003-.394z'
        clipRule='evenodd'></path>
      <path
        fill='#F7A63F'
        fillRule='evenodd'
        d='M14.867 6.58l2.242.159c.078.138.158.275.24.411l-2.49-.177c0-.132.003-.263.008-.394z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA73F'
        fillRule='evenodd'
        d='M14.882 6.318l2.079.148c.073.138.148.274.226.41l-2.324-.166c.003-.131.01-.262.019-.392z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA73F'
        fillRule='evenodd'
        d='M14.903 6.057l1.917.137c.07.137.14.273.214.408l-2.16-.154c.006-.13.016-.261.029-.391z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA93F'
        fillRule='evenodd'
        d='M14.932 5.796l1.757.125c.064.137.13.274.2.408l-1.998-.142c.01-.13.024-.261.04-.391z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA93F'
        fillRule='evenodd'
        d='M14.968 5.536l1.598.114c.06.137.122.273.188.407l-1.838-.13c.015-.131.032-.261.052-.39z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA93F'
        fillRule='evenodd'
        d='M15.013 5.277l1.438.102c.056.137.114.272.175.407l-1.677-.12c.018-.13.04-.26.064-.39z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA93F'
        fillRule='evenodd'
        d='M15.065 5.018l1.28.091c.05.136.105.271.162.405l-1.517-.108c.022-.13.047-.26.075-.388z'
        clipRule='evenodd'></path>
      <path
        fill='#FAA93F'
        fillRule='evenodd'
        d='M15.126 4.76l1.12.08c.047.136.098.27.15.404l-1.358-.096a8.18 8.18 0 01.088-.388z'
        clipRule='evenodd'></path>
      <path
        fill='#FAAB3E'
        fillRule='evenodd'
        d='M15.195 4.502l.961.069c.043.135.09.27.138.403l-1.2-.085c.031-.13.065-.259.101-.387z'
        clipRule='evenodd'></path>
      <path
        fill='#FAAB3E'
        fillRule='evenodd'
        d='M15.274 4.245l.801.057.03.102c.03.1.062.201.095.3l-1.04-.073c.034-.13.072-.258.114-.386z'
        clipRule='evenodd'></path>
      <path
        fill='#FAAB3E'
        fillRule='evenodd'
        d='M15.36 3.989l.645.046c.03.123.063.246.1.369l.01.032-.882-.062c.04-.13.082-.258.128-.385z'
        clipRule='evenodd'></path>
      <path
        fill='#FBAC3E'
        fillRule='evenodd'
        d='M15.458 3.733l.487.035c.027.134.058.267.093.4l-.722-.05c.044-.13.091-.258.142-.385z'
        clipRule='evenodd'></path>
      <path
        fill='#FBAC3E'
        fillRule='evenodd'
        d='M15.564 3.478l.33.024c.024.133.05.266.08.4l-.566-.041c.049-.128.1-.256.156-.383z'
        clipRule='evenodd'></path>
      <path
        fill='#FBAC3E'
        fillRule='evenodd'
        d='M15.919 3.635l-.41-.03c.092-.217.193-.433.304-.646.03.226.063.451.106.676z'
        clipRule='evenodd'></path>
    </svg>
  );
}
